'use strict';

var React = require('react');
var fa = require('react-icons/fa');
var reactBootstrap = require('react-bootstrap');
var sha256 = require('crypto-js/sha256');
var ReactDatePicker = require('react-datepicker');
require('react-datepicker/dist/react-datepicker.css');
var gr = require('react-icons/gr');
var vsc = require('react-icons/vsc');
var ifsReactLib = require('@tunz/ifs-react-lib');
var http = require('@tunz/http');
var client = require('react-dom/client');
var recharts = require('recharts');
var messageDisplayer = require('@tunz/message-displayer');

// eslint-disable-next-line no-shadow
exports.SortOrder = void 0;
(function (SortOrder) {
    SortOrder["Undefined"] = "none";
    SortOrder["Asc"] = "asc";
    SortOrder["Desc"] = "desc";
})(exports.SortOrder || (exports.SortOrder = {}));
/**
 * The sort info is a helper class to keep track of sort field and sort order.
 */
class SortInfo {
    /**
     * Creates a new SortInfo.
     *
     * @param {string} field The field to sort on
     * @param {SortOrder} order The direction of the sort.
     */
    constructor(field = undefined, order = exports.SortOrder.Undefined) {
        this.field = field;
        this.order = order;
    }
    /**
     * Set the new field with the default sort order (Asc)
     * or if the field is the same, rotates the sort order.
     *
     * @param {string} field the field to sort
     * @throws {Error} if the order is not a SortOrder.
     */
    update(field) {
        if (field === this.field) {
            switch (this.order) {
                case exports.SortOrder.Asc:
                    this.order = exports.SortOrder.Desc;
                    break;
                case exports.SortOrder.Desc:
                    this.order = exports.SortOrder.Undefined;
                    break;
                case exports.SortOrder.Undefined:
                    this.order = exports.SortOrder.Asc;
                    break;
                default:
                    throw Error(`Expected a SortOrder. Got: ${this.order}`);
            }
        }
        else {
            this.field = field;
            this.order = exports.SortOrder.Asc;
        }
    }
}

var style$k = {"error":"SortIcon-module_error__5Va4U","sortIcon":"SortIcon-module_sortIcon__o8lDw","sortIconInactive":"SortIcon-module_sortIconInactive__o6FQs"};

/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
class SortIcon extends React.Component {
    constructor() {
        super(...arguments);
        /** Toggle the icon based on sorting order */
        this.setSortIcon = () => {
            let sortIcon = null;
            if (this.props.sortable) {
                switch (this.props.sortOrder) {
                    case exports.SortOrder.Asc:
                        sortIcon = React.createElement(fa.FaSortUp, { className: style$k.sortIcon });
                        break;
                    case exports.SortOrder.Desc:
                        sortIcon = React.createElement(fa.FaSortDown, { className: style$k.sortIcon });
                        break;
                    default:
                        sortIcon = React.createElement(fa.FaSort, { className: style$k.sortIconInactive });
                        break;
                }
            }
            return sortIcon;
        };
    }
    render() {
        const { onSort } = this.props;
        const icon = this.setSortIcon();
        return (React.createElement("button", { className: style$k.sortIcon, onClick: onSort, type: "button" }, icon));
    }
}
SortIcon.defaultProps = {
    sortable: false,
    sortOrder: null,
    onSort: null,
};

var style$j = {"error":"InputFilter-module_error__Dp80J","filterInput":"InputFilter-module_filterInput__UIBaC"};

const InputFilter = ({ field, value, onFilter = () => undefined, filterType = 'text', customClass = '', valueRegex = undefined, invalidValueMsg = '', }) => {
    const [isInputValid, setIsInputValid] = React.useState(true);
    const inputRef = React.useRef(null);
    React.useEffect(() => {
        // settings ref value when input receive value from "outside" (url or via button...)
        if (inputRef.current) {
            inputRef.current.value = value ? value.toString() : '';
        }
    }, [value]);
    const handleOnChange = (val) => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setIsInputValid(true);
        if (!valueRegex || valueRegex.test(val)) {
            onFilter(val, field);
        }
        else {
            setIsInputValid(false);
        }
    };
    return (React.createElement(reactBootstrap.FormGroup, { className: "position-relative" },
        React.createElement(reactBootstrap.FormControl, { ref: inputRef, key: `${field}`, className: `${style$j.filterInput} ${customClass}`, size: "sm", type: filterType, onChange: (e) => handleOnChange(e.target.value), "data-testid": `InputFilter-${field}`, isInvalid: !isInputValid }),
        valueRegex && invalidValueMsg && (React.createElement(reactBootstrap.FormControl.Feedback, { type: "invalid", tooltip: true }, invalidValueMsg))));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var style$i = {"error":"DropDownListFilter-module_error__DEXWt","option":"DropDownListFilter-module_option__90Hcx"};

class Digest {
}
Digest.sha256 = (r) => sha256(JSON.stringify(r)).toString();

class DropDownListFilter extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { options: [] };
        this.handleOnChange = (value) => {
            const { onFilter } = this.props;
            onFilter(value);
        };
        // eslint-disable-next-line class-methods-use-this
        this.renderOption = (key, label) => (React.createElement("option", { key: key, className: style$i.option, value: key }, label));
        this.renderOptionGroup = (groupedOptions, optionGroupName) => groupedOptions[0] === 'All' ? (this.renderOption(0, optionGroupName)) : (React.createElement("optgroup", { key: optionGroupName, label: optionGroupName }, groupedOptions[optionGroupName].map(({ key, label }) => this.renderOption(key, label))));
    }
    // eslint-disable-next-line react/sort-comp
    setOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            const { filterValuesList } = this.props;
            const resolvedValues = typeof filterValuesList === 'function'
                ? yield filterValuesList()
                : yield filterValuesList;
            this.setState({
                options: resolvedValues,
            });
        });
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setOptions();
        });
    }
    componentDidUpdate(prevProps) {
        return __awaiter(this, void 0, void 0, function* () {
            const { filterValuesList } = this.props;
            if (Digest.sha256(prevProps.filterValuesList) !== Digest.sha256(filterValuesList)) {
                yield this.setOptions();
            }
        });
    }
    render() {
        const { value, field } = this.props;
        const { options } = this.state;
        const groupedOptions = options.reduce((acc, option) => {
            if (option.key === 0) {
                return {
                    All: [option],
                };
            }
            if (option.optionGroup === undefined) {
                return undefined;
            }
            const accOptionGroup = acc[option.optionGroup] || [];
            return Object.assign(Object.assign({}, acc), { [option.optionGroup]: [...accOptionGroup, option] });
        }, {});
        return (React.createElement(reactBootstrap.Form.Select, { size: "sm", onChange: (e) => this.handleOnChange(e.target.value), value: value, disabled: options.length === 0, "data-testid": `DropDownListFilter-${field}` }, groupedOptions
            ? Object.keys(groupedOptions).map((optionGroupName) => this.renderOptionGroup(groupedOptions, optionGroupName))
            : options.map((keyLabel) => this.renderOption(keyLabel.key, keyLabel.label))));
    }
}
DropDownListFilter.defaultProps = {
    onFilter: () => undefined,
    filterValuesList: [],
    value: undefined,
    field: '',
};

var style$h = {"error":"RangeFilter-module_error__1BW5b","filterRange":"RangeFilter-module_filterRange__TunzJ","filterRangeFrom":"RangeFilter-module_filterRangeFrom__YjW5e","filterRangeTo":"RangeFilter-module_filterRangeTo__Egjs4"};

const RangeFilter = ({ field = '', value = '', onFilter = () => undefined, }) => {
    const fromDefaultValue = value ? value.toString().split('|')[0] : '';
    const toDefaultValue = value ? value.toString().split('|')[1] : '';
    const [fromValue, setFromValue] = React.useState(fromDefaultValue);
    const [toValue, setToValue] = React.useState(toDefaultValue);
    // to allow table rendering with default values of the filters
    React.useEffect(() => {
        if (value !== '') {
            onFilter(value.toString());
        }
    }, []);
    React.useEffect(() => {
        setFromValue(fromDefaultValue);
        setToValue(toDefaultValue);
    }, [fromDefaultValue, toDefaultValue]);
    const onInputRestrictToNumericValues = (event) => {
        const target = event.target;
        target.value = target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    };
    const getRangeValue = () => {
        if (fromValue !== '' && toValue !== '') {
            return `From ${fromValue} to ${toValue}`;
        }
        if (fromValue === '' && toValue === '') {
            return '';
        }
        if (toValue === '') {
            return `From ${fromValue}`;
        }
        if (fromValue === '') {
            return `To ${toValue}`;
        }
        return '';
    };
    const onSubmit = (e) => {
        e.preventDefault();
        if (fromValue === '' && toValue === '') {
            onFilter('');
        }
        else {
            onFilter(`${fromValue}|${toValue}`);
        }
    };
    const popover = (React.createElement(reactBootstrap.Popover, { id: "range-filter-popover" },
        React.createElement(reactBootstrap.Popover.Body, null,
            React.createElement(reactBootstrap.Form, { onSubmit: onSubmit },
                React.createElement(reactBootstrap.FormGroup, { className: style$h.filterRangeFrom },
                    React.createElement(reactBootstrap.FormLabel, { style: { fontSize: '10px', margin: '2px 2px' } }, "From"),
                    React.createElement(reactBootstrap.FormControl, { size: "sm", type: "text", onInput: (e) => onInputRestrictToNumericValues(e), value: fromValue, onChange: (e) => setFromValue(e.target.value), "data-testid": `RangeFilter-from-${field}` })),
                React.createElement(reactBootstrap.FormGroup, { className: style$h.filterRangeTo },
                    React.createElement(reactBootstrap.FormLabel, { style: { fontSize: '10px', margin: '2px 1px 0px 16px' } }, "To"),
                    React.createElement(reactBootstrap.FormControl, { size: "sm", type: "text", onInput: (e) => onInputRestrictToNumericValues(e), value: toValue, onChange: (e) => setToValue(e.target.value), "data-testid": `RangeFilter-to-${field}` })),
                React.createElement(reactBootstrap.Button, { type: "submit", "data-testid": "rangeFilterSubmitButton", size: "sm", className: "d-block mt-2 mx-auto" }, "Filter")))));
    return (React.createElement(reactBootstrap.OverlayTrigger, { trigger: "click", placement: "top", overlay: popover, rootClose: true },
        React.createElement(reactBootstrap.FormControl, { className: style$h.filterRange, size: "sm", title: getRangeValue(), value: getRangeValue(), "data-testid": `RangeFilter-${field}`, readOnly: true })));
};
RangeFilter.defaultProps = {
    field: '',
    value: '',
};

let DateHelper$1 = class DateHelper {
    static convertDateToISOString(date) {
        if (!date) {
            return undefined;
        }
        // Convert to UTC date to prevent the initial selection from displaying the day as previous
        const dateUTC = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        return dateUTC.toISOString().split('T')[0];
    }
};

var _a$1;
const DatePicker = (_a$1 = ReactDatePicker.default) !== null && _a$1 !== void 0 ? _a$1 : ReactDatePicker;
class DateFilter extends React.Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = (date) => {
            const { onFilter } = this.props;
            onFilter(DateHelper$1.convertDateToISOString(date));
        };
    }
    render() {
        const { defaultDate, field } = this.props;
        const date = new Date(defaultDate);
        return (React.createElement(DatePicker, { selected: !Number.isNaN(date.getDate()) ? date : undefined, onChange: this.handleOnChange, dateFormat: "yyyy-MM-dd", id: `DateFilter-${field}`, className: "form-control form-control-sm" }));
    }
}

/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
class Filter extends React.Component {
    constructor() {
        super(...arguments);
        this.apply = (filterValue) => {
            const { filterParameters: { field, onFilter }, } = this.props;
            if (field) {
                onFilter(field, filterValue);
            }
        };
        this.applyCustomFilter = (filterValue, field) => {
            const { filterParameters: { onFilter }, } = this.props;
            if (field) {
                onFilter(field, filterValue);
            }
        };
    }
    render() {
        let filter = null;
        const { filterParameters } = this.props;
        if (filterParameters.filtered) {
            switch (filterParameters.filterType) {
                case 'dropDownList':
                    filter = (React.createElement(DropDownListFilter, { onFilter: this.apply, filterValuesList: filterParameters.filterValuesList, value: filterParameters.value || '', field: filterParameters.field }));
                    break;
                case 'rangeFilter':
                    filter = (React.createElement(RangeFilter, { onFilter: this.apply, value: filterParameters.value, field: filterParameters.field }));
                    break;
                case 'dateFilter':
                    filter = (React.createElement(DateFilter, { onFilter: this.apply, defaultDate: filterParameters.value, field: filterParameters.field }));
                    break;
                case 'custom':
                    if (filterParameters.customFilter) {
                        filter = React.createElement(filterParameters.customFilter.component, {
                            filterValues: filterParameters.filterValues,
                            onFilter: (value, paramName) => this.applyCustomFilter(value, paramName),
                        });
                    }
                    break;
                default:
                    filter = (React.createElement(InputFilter, { onFilter: this.apply, filterType: filterParameters.filterType, value: filterParameters.value, field: filterParameters.field, customClass: filterParameters.filterClassName, valueRegex: filterParameters.filterValueRegex, invalidValueMsg: filterParameters.filterInvalidValueMsg }));
            }
        }
        return filter;
    }
}
Filter.defaultProps = {
    filterParameters: {
        onFilter: () => undefined,
    },
};

var style$g = {"error":"RawTable-module_error__Jn8Hq","tableWrapper":"RawTable-module_tableWrapper__xCgR-","expandedRow":"RawTable-module_expandedRow__blX-w","alignRight":"RawTable-module_alignRight__KoZkZ","rawHeader":"RawTable-module_rawHeader__gfXUU","rawFooter":"RawTable-module_rawFooter__Vc-ka","title":"RawTable-module_title__6O-Go","subTitle":"RawTable-module_subTitle__UEcY5","loading":"RawTable-module_loading__1I9Ts"};

// ----------------------------------------------------------------------
// DEFAULT PROPS
const defaultPropsCommon = {
    loading: false,
    title: '',
};
const defaultPropsRawHeader = {
    subTitle: '',
    header: undefined,
    children: undefined,
};
const defaultExpandComponent = () => React.createElement("div", null);
const defaultPropsRawInnerTable = {
    isExpandable: false,
    customExpandButtonTitle: 'Expand / collapse details',
    autoExpandOnSingleResult: true,
    onExpandComponent: defaultExpandComponent,
    onSort: () => undefined,
    onFilter: () => undefined,
    onClearFilters: () => undefined,
    filterValues: new Map(),
    onChildUpdate: () => undefined,
    renderColumnsHeader: true,
    allowExpandAll: true,
    allowExport: false,
    emptyMessage: false,
    additionalActions: undefined,
    additionalHeaderActions: undefined,
};
const defaultPropsRawFooter = {
    footer: undefined,
};

const getTitles = (title, subTitle) => {
    if (title.length > 0 || subTitle.length > 0) {
        return (React.createElement("div", null,
            title.length > 0 && React.createElement("div", { className: style$g.title }, title),
            subTitle.length > 0 && React.createElement("div", { className: style$g.subTitle }, subTitle)));
    }
    return undefined;
};
const RawHeader = ({ loading = false, title = '', subTitle = '', header = undefined, children = undefined, }) => {
    let className = style$g.rawHeader;
    let dataTestId = '';
    if (loading) {
        className += ` ${style$g.loading}`;
        dataTestId = 'loadingTable';
    }
    else {
        dataTestId = 'loadedTable';
    }
    return (React.createElement("div", { className: className, "data-testid": dataTestId },
        getTitles(title, subTitle),
        header,
        children));
};

// This is in a separate file to ease mocking during tests
const getSearch = () => document.location.search;
const pushSearch = (search) => {
    window.history.pushState({}, '', `${window.location.pathname}?${search.toString()}${window.location.hash}`);
};

const getFilterName = (column) => column.paramForFilterQuery ? column.paramForFilterQuery : column.field;
const getFilterNameInUrl = (column, isCustomFilter = false) => { var _a; return isCustomFilter ? (_a = column === null || column === void 0 ? void 0 : column.customFilter) === null || _a === void 0 ? void 0 : _a.paramForFilterInUrl : column === null || column === void 0 ? void 0 : column.paramForFilterInUrl; };
const getDefaultValue = (column, getFromUrl, isCustomFilter = false, searchParams = new URLSearchParams(getSearch())) => {
    let returnValue;
    if (getFromUrl &&
        searchParams.has(getFilterNameInUrl(column, isCustomFilter) || column.field)) {
        returnValue = searchParams.get(getFilterNameInUrl(column, isCustomFilter) || column.field);
    }
    else if (column.filterDefaultValue) {
        returnValue = `${column.filterDefaultValue}`;
    }
    return returnValue;
};

/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/control-has-associated-label */
class FiltersHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.hasFilters = this.props.columns.find((c) => c.filtered) !== undefined;
        this.clearFilters = () => {
            const { onClearFilters, filterValues } = this.props;
            onClearFilters(Array.from(filterValues.keys()));
        };
        this.getCurrentValue = (column) => {
            const { filterValues } = this.props;
            const filterValue = filterValues.get(getFilterName(column));
            return filterValue === undefined ? column.filterDefaultValue : filterValue.value;
        };
        this.transformFilterValues = () => {
            const { filterValues } = this.props;
            const result = {};
            filterValues.forEach((v, k) => {
                result[k] = v.value;
            });
            return result;
        };
    }
    render() {
        const filters = [];
        const { columns, onFilter } = this.props;
        columns.forEach((c) => !c.hidden &&
            filters.push(React.createElement("th", { key: c.field },
                React.createElement(Filter, { filterParameters: {
                        filtered: c.filtered,
                        field: c.paramForFilterQuery ? c.paramForFilterQuery : c.field,
                        filterType: c.filterType,
                        customFilter: c.customFilter,
                        filterValuesList: c.filterValuesList,
                        onFilter,
                        value: this.getCurrentValue(c),
                        filterValues: this.transformFilterValues(),
                        filterClassName: c.filterClassName,
                        filterValueRegex: c.filterValueRegex,
                        filterInvalidValueMsg: c.filterInvalidValueMsg,
                    } }))));
        if (this.hasFilters) {
            filters.push(React.createElement("th", { className: "text-right text-end", key: "clearButton" },
                React.createElement(reactBootstrap.Button, { variant: "outline-secondary", size: "sm", onClick: this.clearFilters, title: "Clear filters", "data-testid": "clearFiltersButton" },
                    React.createElement(fa.FaTimesCircle, null))));
        }
        else {
            filters.push(React.createElement("th", { key: "clearButton" }));
        }
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return this.hasFilters ? React.createElement("tr", null, filters) : React.createElement(React.Fragment, null);
    }
}
FiltersHeader.defaultProps = {
    onFilter: () => undefined,
    onClearFilters: () => undefined,
    shouldDelayFilter: true,
    filterValues: new Map(),
};

var style$f = {"error":"RawTh-module_error__uxQv8","rawTh":"RawTh-module_rawTh__a3lwT","noFlex":"RawTh-module_noFlex__rfDzZ","flex":"RawTh-module_flex__7ApHi"};

const InfoIcon = ({ info = '' }) => {
    const popover = React.createElement(reactBootstrap.Tooltip, null, info);
    if (info) {
        return (React.createElement(reactBootstrap.OverlayTrigger, { placement: "top", overlay: popover },
            React.createElement(reactBootstrap.Button, { size: "sm", variant: "link" },
                React.createElement(fa.FaInfoCircle, null))));
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return React.createElement(React.Fragment, null);
};
InfoIcon.defaultProps = {
    info: '',
};

/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/**
 * This renders a th element. If the column is sortable, a sort icon will appear in the element.
 * The onSort callback function is triggered when clicking the th element.
 */
class RawTh extends React.Component {
    constructor() {
        super(...arguments);
        this.getSortIcon = () => {
            const { sortable, sortOrder, value, info, field } = this.props;
            if (sortable) {
                return (React.createElement("div", { onClick: this.handleSortingClick, role: "button", tabIndex: 0, className: style$f.flex, onKeyDown: this.handleSortingClick, "data-testid": `sort-${field}` },
                    React.createElement(SortIcon, { sortable: sortable, sortOrder: sortOrder, onSort: this.handleSortingClick }),
                    value,
                    React.createElement(InfoIcon, { info: info })));
            }
            return (React.createElement("div", { className: style$f.flex },
                value,
                React.createElement(InfoIcon, { info: info })));
        };
        /**
         * Handles clicking the sort icon.
         *
         * @param {MouseEvent} e The dom event
         */
        this.handleSortingClick = (e) => {
            e.stopPropagation();
            const { field, paramForOrderQuery, sortable, onSort } = this.props;
            if (sortable) {
                if (paramForOrderQuery) {
                    onSort(paramForOrderQuery);
                }
                else {
                    onSort(field);
                }
            }
        };
    }
    render() {
        const { headerClassName } = this.props;
        const sortableHeader = this.getSortIcon();
        return React.createElement("th", { className: `${style$f.rawTh} ${headerClassName}` }, sortableHeader);
    }
}
RawTh.defaultProps = {
    sortable: false,
    sortOrder: null,
    value: '',
    onSort: null,
    headerClassName: '',
    info: '',
};

/* eslint-disable jsx-a11y/control-has-associated-label,react/jsx-props-no-spreading */
const columnsHeader = ({ columns, isExpandable = false, allowExpandAll = true, allowExport = false, onExportData = () => undefined, onExpandAll = () => undefined, onCollapseAll = () => undefined, allLinesExpanded = false, onSort = () => undefined, onChildUpdate = () => undefined, lastColumnNeeded = false, additionalHeaderActions = undefined, }) => (React.createElement("tr", null,
    columns.map((c) => !c.hidden ? (React.createElement(RawTh, Object.assign({ key: `th-${c.field}-${c.name}`, value: c.name }, c, { onSort: onSort, sortable: c.sortable, info: c.info }))) : null),
    lastColumnNeeded ? (React.createElement("th", { key: "th-expand", className: "text-right text-end" },
        allowExport && (React.createElement(reactBootstrap.Button, { variant: "outline-secondary", size: "sm", onClick: onExportData, "data-testid": "export-button", title: "Export data to CSV", className: "ms-2 ml-2" },
            React.createElement(gr.GrDocumentCsv, null))),
        isExpandable &&
            allowExpandAll &&
            (allLinesExpanded ? (React.createElement(reactBootstrap.Button, { variant: "outline-secondary", size: "sm", "data-testid": "collapse-all-button", onClick: onCollapseAll, title: "Collapse all rows", className: "ms-2 ml-2" },
                React.createElement(vsc.VscRootFolder, null))) : (React.createElement(reactBootstrap.Button, { variant: "outline-secondary", size: "sm", "data-testid": "expand-all-button", onClick: onExpandAll, title: "Expand all rows", className: "ms-2 ml-2" },
                React.createElement(vsc.VscRootFolderOpened, null)))),
        additionalHeaderActions &&
            React.createElement(additionalHeaderActions, {
                onChildUpdate,
            }))) : null));

/**
 * Catches errors for cell rendering.
 */
class CellErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { error: undefined };
    }
    /**
     * Updates the state with the error info.
     *
     * @param {Error} error The error thrown.
     * @param {React.ErrorInfo} info The stacktrace.
     * @override
     */
    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({
            error,
        });
        // eslint-disable-next-line no-console
        console.error(error, info);
    }
    /**
     * @override
     */
    render() {
        const { children } = this.props;
        const { error } = this.state;
        if (error !== undefined) {
            const { message } = error;
            // You can render any custom fallback UI
            return React.createElement("span", { className: style$g.error }, message);
        }
        return children;
    }
}

var rowStyle = {"rawRow":"RawRow-module_rawRow__q2eTd"};

class RawRow extends React.Component {
    constructor(props) {
        super(props);
        this.getAdditionalColumn = (rowId, isExpanded) => {
            const { isExpandable, customExpandButtonTitle, toggleExpandNode, lastColumnNeeded, additionalActions, record, onChildUpdate, } = this.props;
            if (!isExpandable && additionalActions === undefined) {
                if (lastColumnNeeded) {
                    // eslint-disable-next-line jsx-a11y/control-has-associated-label
                    return React.createElement("td", null);
                }
                return null;
            }
            return (React.createElement("td", { className: rowStyle.rawRow },
                additionalActions &&
                    React.createElement(additionalActions, {
                        value: rowId,
                        record,
                        onChildUpdate,
                    }),
                isExpandable && (React.createElement(reactBootstrap.Button, { variant: "outline-secondary", size: "sm", onClick: () => toggleExpandNode(rowId), title: customExpandButtonTitle || 'Expand / collapse details', className: "ml-2 ms-2", "data-testid": `expand-${rowId}` }, isExpanded ? React.createElement(fa.FaRegFolderOpen, null) : React.createElement(fa.FaRegFolder, null)))));
        };
        this.recordHash = Digest.sha256(props.record);
    }
    shouldComponentUpdate(nextProps) {
        const { isExpanded } = this.props;
        if (isExpanded === nextProps.isExpanded && // valid even if not expandable
            // check recordHash in case of... not sure if it is even possible
            this.recordHash === Digest.sha256(nextProps.record)) {
            // no need to rerender
            return false;
        }
        return true;
    }
    componentDidUpdate() {
        const { record } = this.props;
        this.recordHash = Digest.sha256(record);
    }
    render() {
        const { columns, rowId, record, isExpanded, onExpandComponent, onChildUpdate } = this.props;
        const rows = [
            React.createElement("tr", { key: rowId },
                columns.map((c, i) => {
                    const columnKey = `${c.field}-${i}`;
                    const { renderer } = c;
                    const value = record[c.field];
                    if (value != null && typeof value === 'object' && renderer === undefined) {
                        throw new Error('No custom renderer found for field of type object.');
                    }
                    const renderedValue = renderer === undefined ? (value) : (React.createElement(CellErrorBoundary, null, React.createElement(renderer, {
                        value,
                        record,
                        onChildUpdate,
                    })));
                    return (React.createElement("td", { key: columnKey, className: c.cellClassName }, renderedValue));
                }),
                this.getAdditionalColumn(rowId, isExpanded)),
        ];
        if (isExpanded) {
            rows.push(React.createElement("tr", { key: `${rowId}-expanded` },
                React.createElement("td", { className: style$g.expandedRow, colSpan: columns.length + 1 },
                    React.createElement("div", null, React.createElement(onExpandComponent, {
                        record,
                        onChildUpdate,
                    })))));
        }
        return rows;
    }
}

const download = (filename, text) => {
    const element = document.createElement('a');
    element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

const objectsToCSV = (records, columns) => {
    const headers = columns.map((c) => JSON.stringify(c.name)).toString();
    const dataLines = records
        .map((row) => columns.map((c) => JSON.stringify(row[c.field])).toString())
        .join('\n');
    return `${headers}\n${dataLines}`;
};
const exportToCsv = (title, records, columns) => {
    const text = objectsToCSV(records, columns);
    const date = new Date();
    download(`${title}-${date.toLocaleDateString()}-${date.toLocaleTimeString()}.csv`, text);
};

var style$e = {"emptyRowCell":"EmptyRow-module_emptyRowCell__ZH9Aw"};

const DEFAULT_EMPTY_MESSAGE = 'There is no data';
const EmptyRow = ({ size, emptyMessage }) => {
    if (emptyMessage === false) {
        return null;
    }
    let component = emptyMessage;
    if (emptyMessage === true) {
        component = DEFAULT_EMPTY_MESSAGE;
    }
    return (React.createElement("tr", null,
        React.createElement("td", { colSpan: size, className: style$e.emptyRowCell },
            React.createElement("div", { className: "text-center" }, component))));
};

/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/**
 * <b>Simple table implementation.</b>
 *
 * This could be used for simple case or wrapped to be used in more complex cases.
 */
class RawInnerTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedRows: [],
        };
        this.lastColumnNeeded = (records) => {
            const { allowExport, additionalActions, additionalHeaderActions, columns } = this.props;
            const filtersPresent = columns.some((c) => c.filtered);
            return (this.isAnyRowExpandable(records) ||
                allowExport ||
                additionalActions !== undefined ||
                additionalHeaderActions !== undefined ||
                filtersPresent);
        };
        this.buildColGroup = () => (React.createElement("colgroup", { key: "colgroup" },
            this.props.columns.map((c) => !c.hidden ? React.createElement("col", { key: `col-${c.field}-${c.name}`, width: c.width }) : null),
            this.lastColumnNeeded(this.props.records) ? React.createElement("col", { key: "col-additional" }) : null));
        this.allLineExpanded = () => this.props.records.filter((record, index) => {
            if (!this.isAnyRowExpandable(Array.of(record))) {
                return false;
            }
            const rowId = this.getRowId(record, index);
            return !this.state.expandedRows.includes(rowId);
        }).length === 0;
        this.toggleExpandNode = (node) => {
            let er = this.state.expandedRows;
            if (this.state.expandedRows.includes(node)) {
                er = this.state.expandedRows.filter((r) => r !== node);
            }
            else {
                er.push(node);
            }
            this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { expandedRows: er })));
        };
        this.onExpandAll = () => {
            const er = this.state.expandedRows;
            this.props.records.forEach((record, index) => {
                if (!this.isAnyRowExpandable(Array.of(record))) {
                    return;
                }
                const rowId = this.getRowId(record, index);
                if (!this.state.expandedRows.includes(rowId)) {
                    er.push(rowId);
                }
            });
            this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { expandedRows: er })));
        };
        this.onCollapseAll = () => {
            this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { expandedRows: [] })));
        };
        this.onExportData = () => {
            const { onExportData, records, columns, title } = this.props;
            if (onExportData) {
                onExportData(records, columns);
            }
            else {
                const exportTitle = title || document.title;
                exportToCsv(exportTitle, records, columns);
            }
        };
        this.renderFilters = () => {
            const { columns, onFilter, onClearFilters, filterValues } = this.props;
            return (React.createElement(FiltersHeader, { columns: columns, onFilter: onFilter, onClearFilters: onClearFilters, filterValues: filterValues }));
        };
        this.renderColumns = () => {
            const { records, renderColumnsHeader, allowExpandAll, allowExport, additionalHeaderActions, onChildUpdate, } = this.props;
            if (renderColumnsHeader) {
                return (React.createElement(columnsHeader, { columns: this.props.columns, isExpandable: this.isAnyRowExpandable(records), allowExpandAll: allowExpandAll, allowExport: allowExport, onExportData: this.onExportData, onExpandAll: this.onExpandAll, onCollapseAll: this.onCollapseAll, allLinesExpanded: this.isAnyRowExpandable(records) && this.allLineExpanded(), onSort: this.props.onSort, lastColumnNeeded: this.lastColumnNeeded(records), onChildUpdate: onChildUpdate, additionalHeaderActions: additionalHeaderActions }));
            }
            return null;
        };
        this.renderRows = () => {
            const { records, customExpandButtonTitle, onExpandComponent, onChildUpdate, emptyMessage, additionalActions, } = this.props;
            const { expandedRows } = this.state;
            if (emptyMessage !== undefined &&
                emptyMessage !== false &&
                (records === undefined || records.length === 0)) {
                const spanNumber = this.visibleColumns.length + (this.lastColumnNeeded(records) ? 1 : 0);
                return React.createElement(EmptyRow, { size: spanNumber, emptyMessage: emptyMessage });
            }
            return (records &&
                records.map((record, index) => {
                    const rowId = this.getRowId(record, index);
                    return (React.createElement(RawRow, { key: rowId, columns: this.visibleColumns, rowId: rowId, record: record, isExpandable: this.isAnyRowExpandable(Array.of(record)), customExpandButtonTitle: customExpandButtonTitle, lastColumnNeeded: this.lastColumnNeeded(Array.of(record)), isExpanded: expandedRows.includes(rowId), onExpandComponent: onExpandComponent, toggleExpandNode: this.toggleExpandNode, onChildUpdate: onChildUpdate, additionalActions: additionalActions }));
                }));
        };
        this.idColumns = props.columns.filter((c) => c.isKey);
        this.visibleColumns = props.columns.filter((c) => !c.hidden);
    }
    componentDidMount() {
        const { records } = this.props;
        if (this.isAnyRowExpandable(records)) {
            if (this.idColumns.length === 0) {
                // eslint-disable-next-line no-console
                console.warn('There is no key column for the table. Expanding a row may have strange behaviour.');
            }
        }
    }
    shouldComponentUpdate(nextProps) {
        if (!nextProps.loading ||
            nextProps.records === undefined ||
            nextProps.records.length === 0) {
            return true;
        }
        // no need to rerender during
        return false;
    }
    componentDidUpdate() {
        const { records, autoExpandOnSingleResult } = this.props;
        const { expandedRows } = this.state;
        if (autoExpandOnSingleResult && records.length === 1) {
            if (this.isAnyRowExpandable(records)) {
                const rowId = this.getRowId(records[0], 0);
                if (!expandedRows.includes(rowId)) {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState((state) => (Object.assign(Object.assign({}, state), { expandedRows: [rowId] })));
                }
            }
        }
    }
    getRowId(record, index) {
        if (this.idColumns.length > 0) {
            return this.idColumns.map((keyColumn) => `${record[keyColumn.field]}`).join('-');
        }
        return `${index}`;
    }
    isAnyRowExpandable(records) {
        const { isExpandable } = this.props;
        if (typeof isExpandable !== 'function') {
            return isExpandable;
        }
        return records.some((record) => isExpandable(record));
    }
    render() {
        return (React.createElement(reactBootstrap.Table, { size: "sm", hover: true },
            this.buildColGroup(),
            React.createElement("thead", null,
                this.renderColumns(),
                this.renderFilters()),
            React.createElement("tbody", null, this.renderRows())));
    }
}
RawInnerTable.defaultProps = Object.assign(Object.assign({}, defaultPropsCommon), defaultPropsRawInnerTable);

const RawFooter = ({ footer = undefined }) => {
    if (footer) {
        const className = style$g.rawFooter;
        return (React.createElement("div", { className: className, "data-testid": className }, footer));
    }
    return null;
};

/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/prefer-stateless-function */
/**
 * <b>Simple table implementation.</b>
 *
 * This could be used for simple case or wrapped to be used in more complex cases.
 */
class RawTable extends React.Component {
    render() {
        const { title, subTitle, footer } = this.props;
        return (React.createElement("div", { className: style$g.tableWrapper, "data-testid": `${title}_${subTitle}` },
            React.createElement(RawHeader, Object.assign({}, this.props)),
            React.createElement(RawInnerTable, Object.assign({}, this.props)),
            React.createElement(RawFooter, { footer: footer })));
    }
}
RawTable.defaultProps = Object.assign(Object.assign(Object.assign(Object.assign({}, defaultPropsCommon), defaultPropsRawHeader), defaultPropsRawInnerTable), defaultPropsRawFooter);

/**
 * Displays the detail of an object (key - value) in a table format.
 * This can be easily used as detail of a row in another table.
 */
const RecordDetail = (props) => {
    const columns = [
        {
            field: 'key',
            name: 'Key',
            isKey: true,
        },
        {
            field: 'value',
            name: 'Value',
        },
    ];
    const { record } = props;
    const data = Object.keys(record).map((k) => ({
        key: k,
        value: record[k],
    }));
    return React.createElement(RawTable, { columns: columns, records: data });
};

/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
class NumberInput extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.recordAnswer = (event) => {
            const { value } = event.currentTarget;
            const { name, onChange } = this.props;
            if (onChange) {
                onChange(name, { value });
            }
        };
        this.endEditing = (event) => {
            const { value } = event.target;
            const { onEditEnd } = this.props;
            if (onEditEnd) {
                onEditEnd(value);
            }
        };
    }
    render() {
        const { name, min, max, mandatory, value, tooltip, readonly, placeholder } = this.props;
        return (React.createElement(reactBootstrap.Form.Group, { as: reactBootstrap.Row, controlId: name },
            React.createElement(reactBootstrap.Form.Label, { title: tooltip, column: true, sm: "4" },
                name,
                mandatory && React.createElement("span", null, "*")),
            React.createElement(reactBootstrap.Col, { sm: "8" },
                React.createElement(reactBootstrap.Form.Control, { type: "number", placeholder: placeholder, onChange: this.recordAnswer, onBlur: this.endEditing, defaultValue: value, min: min, max: max, name: name, disabled: readonly, "data-testid": `number-input-${name}` }),
                React.createElement(reactBootstrap.FormControl.Feedback, null))));
    }
}
NumberInput.defaultProps = {
    min: Number.MIN_VALUE,
    max: Number.MAX_VALUE,
    mandatory: false,
    onChange: () => undefined,
    onEditEnd: () => undefined,
    value: 0,
    readonly: false,
    placeholder: '',
    tooltip: '',
};

class TextInput extends React.Component {
    constructor() {
        super(...arguments);
        this.recordAnswer = (event) => {
            const { value } = event.currentTarget;
            const { name, onChange } = this.props;
            if (onChange) {
                onChange(name, { value });
            }
        };
        this.endEditing = (event) => {
            const { value } = event.target;
            const { onEditEnd } = this.props;
            if (onEditEnd) {
                onEditEnd(value);
            }
        };
    }
    render() {
        const { name, value, minLength, maxLength, mandatory, readonly, placeholder, tooltip } = this.props;
        return (React.createElement(reactBootstrap.Form.Group, { as: reactBootstrap.Row, controlId: name },
            React.createElement(reactBootstrap.Form.Label, { title: tooltip, column: true, sm: "4" },
                name,
                mandatory && React.createElement("span", null, "*")),
            React.createElement(reactBootstrap.Col, { sm: "8" },
                React.createElement(reactBootstrap.Form.Control, { type: "text", placeholder: placeholder, onChange: this.recordAnswer, onBlur: this.endEditing, defaultValue: value, minLength: minLength, maxLength: maxLength, name: name, disabled: readonly, "data-testid": `text-input-${name}` }),
                React.createElement(reactBootstrap.FormControl.Feedback, null))));
    }
}
TextInput.defaultProps = {
    minLength: 0,
    maxLength: 10000,
    mandatory: false,
    readonly: false,
    onChange: () => undefined,
    onEditEnd: () => undefined,
    value: '',
    placeholder: '',
    tooltip: '',
};

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    NumberInput: NumberInput,
    TextInput: TextInput
});

const isString = (tbd) => typeof tbd === 'string';
const isNumber = (tbd) => typeof tbd === 'number';

var style$d = {"customSeparation":"TunzMerchantIdFormatter-module_customSeparation__VwC3B","firstPart":"TunzMerchantIdFormatter-module_firstPart__Imat0","secondPart":"TunzMerchantIdFormatter-module_secondPart__hgE9g"};

/**
 * Formats a (A|T)MID value with a separation after the checksum
 */
const TunzMerchantIdFormatter = ({ value }) => {
    if (!isString(value)) {
        return React.createElement("span", null, value);
    }
    if (value.length < 5) {
        return React.createElement("span", null, value);
    }
    const firstPart = value.substring(0, 4);
    const secondPart = value.substring(4);
    return (React.createElement("span", null,
        React.createElement("span", { className: style$d.customSeparation },
            React.createElement("span", { className: style$d.firstPart }, firstPart),
            React.createElement("span", { className: style$d.secondPart }, secondPart)),
        React.createElement("br", null)));
};

var style$c = {"container":"ButtonFormatter-module_container__lAs5M","button":"ButtonFormatter-module_button__tyISz"};

/**
 * @Component ButtonFormatter
 */
const ButtonFormatter = (title, icon, onClick, ValueFormatter, permission, isEnabled = () => true, hideButtonWhenDisabled = false) => ({ record, value, onChildUpdate }) => {
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        onClick(record, onChildUpdate);
    });
    const renderButton = () => (React.createElement("span", { className: style$c.button },
        React.createElement(reactBootstrap.Button, { onClick: handleClick, size: "sm", variant: "link", title: title(record), "data-testid": `ButtonFormatter-${title.apply(record).replace(/\s+/g, '-')}`, disabled: !isEnabled(record) }, icon(record))));
    return (React.createElement("div", { className: style$c.container },
        ValueFormatter ? React.createElement(ValueFormatter, { record: record, value: value }) : null,
        (isEnabled(record) || !hideButtonWhenDisabled) &&
            (permission ? (React.createElement(ifsReactLib.Restriction, Object.assign({}, permission), renderButton())) : (renderButton()))));
};

var style$b = {"container":"EditableFormatter-module_container__L-Ez-","button":"EditableFormatter-module_button__QzMOS"};

/* eslint-disable react/jsx-props-no-spreading */
/**
 * @Component EditableFormatter
 */
const EditableFormatter = (ROFormatter, RWFormatter, RWPermissionProps, additionalProps, editingAllowed = () => true, hideButtonWhenNotAllowed = false) => {
    var _a;
    const ROName = ROFormatter.displayName || ROFormatter.name;
    const RWName = RWFormatter.displayName || RWFormatter.name;
    return _a = class extends React.Component {
            constructor() {
                super(...arguments);
                this.state = { editMode: false };
                this.readOnlyMode = (shouldUpdate = false) => {
                    const { onChildUpdate } = this.props;
                    this.setState({ editMode: false });
                    if (shouldUpdate && onChildUpdate) {
                        onChildUpdate();
                    }
                };
                this.writeMode = () => this.setState({ editMode: true });
            }
            render() {
                const { editMode } = this.state;
                const combinedProps = Object.assign(Object.assign({}, this.props), additionalProps);
                if (editMode) {
                    return (React.createElement(RWFormatter, Object.assign({}, combinedProps, { onEditCancel: () => this.readOnlyMode(), onEditSuccess: () => this.readOnlyMode(true) })));
                }
                return (React.createElement("div", { className: style$b.container },
                    React.createElement(ROFormatter, Object.assign({}, this.props)),
                    (editingAllowed(combinedProps.record) || !hideButtonWhenNotAllowed) && (React.createElement(ifsReactLib.Restriction, Object.assign({}, RWPermissionProps),
                        React.createElement("span", { className: style$b.button },
                            React.createElement(reactBootstrap.Button, { onClick: this.writeMode, size: "sm", variant: "link", title: "Edit", "data-testid": "edit-button", disabled: !editingAllowed(combinedProps.record) },
                                React.createElement(fa.FaRegEdit, null)))))));
            }
        },
        _a.displayName = `EditableFormatter(${ROName}, ${RWName})`,
        _a.defaultProps = { onChildUpdate: () => undefined },
        _a;
};

/**
 * Creates a link
 */
const LinkFormatter = (urlBuilder) => ({ value }) => value ? React.createElement("a", { href: urlBuilder(value) }, value) : null;

var style$a = {"longTextFormatter":"LongTextFormatter-module_longTextFormatter__HCy9e"};

/**
 * Allows displaying long text in a table cell.
 * The text will wrap to avoid messing the table's layout
 */
const LongTextFormatter = ({ value = '' }) => (React.createElement("div", { className: style$a.longTextFormatter }, value));

var style$9 = {"monetaryAmount":"MonetaryAmountFormatter-module_monetaryAmount__cq6C1","sign":"MonetaryAmountFormatter-module_sign__4eEII","integerPart":"MonetaryAmountFormatter-module_integerPart__WgxWQ","decimalSeparator":"MonetaryAmountFormatter-module_decimalSeparator__RnIPq","fraction":"MonetaryAmountFormatter-module_fraction__o4K--","moreDigitThanPrecision":"MonetaryAmountFormatter-module_moreDigitThanPrecision__klJgk"};

const CurrencyColors = {
    EUR: '#0B0BA7',
    ZWD: '#0e9a68',
    GBP: '#df071c',
    USD: '#ce7e38',
    HUF: '#48dc20',
    SEK: '#00bcb0',
    DKK: '#259900',
    CHF: '#c98174',
    BGN: '#00ca08',
    AUD: '#8c8c50',
    AED: '#1c1cd0',
    NZD: '#53afbc',
    PLN: '#54AF4F',
    NOK: '#A64CCA',
    SAR: '#a85080',
    JPY: '#bd6954',
    CAD: '#980020',
    ARS: '#77772c',
    BOB: '#3612b8',
    BRL: '#4bc78c',
    CLP: '#e54d04',
    CNY: '#035b6c',
    COP: '#0a6228',
    CZK: '#238DA7',
    EGP: '#6a2a88',
    GEL: '#046c90',
    HKD: '#024698',
    HRK: '#33274c',
    IDR: '#956504',
    ILS: '#cd4d64',
    INR: '#dbab2c',
    ISK: '#0e2e18',
    KRW: '#9f277c',
    KWD: '#c29a68',
    LTL: '#81d5a4',
    MNT: '#2b0bbc',
    MOP: '#3262c8',
    MXN: '#7151e4',
    MYR: '#780850',
    PEN: '#58bc80',
    PHP: '#6d3104',
    PYG: '#e4a830',
    QAR: '#105060',
    RON: '#4612c8',
    RUB: '#703c20',
    SGD: '#d22a78',
    THB: '#ad00e4',
    TRY: '#03776c',
    TWD: '#269a08',
    UAH: '#50a000',
    UYU: '#0808d0',
    VEF: '#406c90',
    ZAR: '#645000',
};

class CurrencyColorProvider {
    static getCurrencyColor(currency) {
        return CurrencyColors[currency];
    }
}

/* eslint-disable react/no-array-index-key */
const getCurrency = (record, currency = (r) => r.currency) => typeof currency === 'string' ? currency : currency(record);
const getStyle = (record, currency = (r) => r.currency) => {
    const curr = getCurrency(record, currency);
    if (curr) {
        return { color: CurrencyColorProvider.getCurrencyColor(curr) };
    }
    return {};
};
const getPrecision = (record, currency = (r) => r.currency) => {
    const curr = getCurrency(record, currency);
    return curr === 'JPY' ? 0 : 2;
};
/**
 * Formats a number value like a monetary amount
 */
const MonetaryAmountFormatterToCustomise = ({ skipPlusSign, skipMinusSign, currency }) => ({ value, record }) => {
    if (value === undefined || (!isNumber(value) && !isString(value))) {
        return null;
    }
    const number = isString(value) ? parseFloat(value) : value;
    if (Number.isNaN(number)) {
        return null;
    }
    const precision = getPrecision(record, currency);
    const formatter = new Intl.NumberFormat('en', {
        minimumIntegerDigits: 1,
        minimumFractionDigits: precision,
        maximumFractionDigits: 20,
        signDisplay: 'always',
    });
    return (React.createElement("div", { className: style$9.monetaryAmount, style: getStyle(record, currency) }, formatter.formatToParts(number).map((part, index) => {
        if ((part.type === 'minusSign' && !skipMinusSign) ||
            (part.type === 'plusSign' && !skipPlusSign)) {
            return (React.createElement("span", { key: index, className: style$9.sign }, part.value));
        }
        if (part.type === 'integer') {
            return (React.createElement("span", { key: index, className: style$9.integerPart }, part.value));
        }
        if (part.type === 'decimal') {
            return (React.createElement("span", { key: index, className: style$9.decimalSeparator }, part.value));
        }
        if (part.type === 'fraction') {
            let className = style$9.fraction;
            let title;
            if (part.value.length > precision) {
                className = `${className} ${style$9.moreDigitThanPrecision}`;
                title = `More Digits Than Currency Precision (i.e. ${precision})`;
            }
            return (React.createElement("span", { key: index, className: className, title: title }, part.value));
        }
        return null;
    })));
};
var MonetaryAmountFormatter = MonetaryAmountFormatterToCustomise({
    skipMinusSign: false,
    skipPlusSign: false,
    currency: undefined,
});

const MonetaryAmountFormatterNoSign = MonetaryAmountFormatterToCustomise({
    skipPlusSign: true,
    skipMinusSign: true,
});
const MonetaryAmountFormatterNoSignEUR = MonetaryAmountFormatterToCustomise({
    skipPlusSign: true,
    skipMinusSign: true,
    currency: 'EUR',
});
const MonetaryAmountFormatterNoPlusSign = MonetaryAmountFormatterToCustomise({
    skipPlusSign: true,
    skipMinusSign: false,
});
const MonetaryAmountFormatterNoPlusSignEUR = MonetaryAmountFormatterToCustomise({
    skipPlusSign: true,
    skipMinusSign: false,
    currency: 'EUR',
});

var style$8 = {"nationalityFormatter":"NationalityFormatter-module_nationalityFormatter__m8mdy"};

/**
 * Formats the country codes always the same way
 */
const NationalityFormatter = ({ value }) => (React.createElement("div", { className: style$8.nationalityFormatter }, value));

var style$7 = {"numberFormatter":"NumberFormatter-module_numberFormatter__tNq4o"};

const defaultFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 20, // Maximum allowed by the documentation
});
/**
 * Formats a number
 */
const NumberFormatter = (precision) => {
    const formatter = precision
        ? new Intl.NumberFormat('en-US', {
            minimumFractionDigits: precision,
            maximumFractionDigits: precision,
            // eslint-disable-next-line no-mixed-spaces-and-tabs
        })
        : defaultFormatter;
    return ({ value }) => {
        if (isNumber(value)) {
            return React.createElement("div", { className: style$7.numberFormatter }, formatter.format(value));
        }
        return React.createElement("span", null, value);
    };
};
var NumberFormatter$1 = NumberFormatter();

/**
 * Takes a path and just display the last element
 */
const PathToNameFormatter = ({ value }) => {
    if (!isString(value)) {
        return React.createElement("span", null, value);
    }
    const name = value.substring(value.lastIndexOf('/') + 1);
    return React.createElement("span", null, name);
};

var style$6 = {"percentageFormatter":"PercentageFormatter-module_percentageFormatter__hwxTO"};

const formatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2,
});
/**
 * Formats a percentage value
 */
const PercentageFormatter = ({ value }) => {
    if (isNumber(value)) {
        return React.createElement("div", { className: style$6.percentageFormatter },
            formatter.format(value),
            " %");
    }
    return React.createElement("span", null, value);
};

var style$5 = {"status":"StatusFormatter-module_status__Cmp22"};

var statuses = {"INIT":"Statuses-module_INIT__x4kt3","ACCEPTED":"Statuses-module_ACCEPTED__OjgBY","approved":"Statuses-module_approved__a9-bf","AVAILABLE":"Statuses-module_AVAILABLE__tU8jP","EXPORTED":"Statuses-module_EXPORTED__86UCN","ACTIVE":"Statuses-module_ACTIVE__NwEYv","ERROR":"Statuses-module_ERROR__9-uCg","BLOCKED":"Statuses-module_BLOCKED__bO-Cz","INACTIVE":"Statuses-module_INACTIVE__5EVrd","DELETED":"Statuses-module_DELETED__RDtOv","DEACTIVATED":"Statuses-module_DEACTIVATED__pPedX","DEPRECATED":"Statuses-module_DEPRECATED__duerB","SECRET":"Statuses-module_SECRET__txfjb","kyc_needed":"Statuses-module_kyc_needed__kLeCD","kycdocs_needed":"Statuses-module_kycdocs_needed__iVOlM","CONFIDENTIAL":"Statuses-module_CONFIDENTIAL__nqJAO","USE_PASSWORD_ONLY":"Statuses-module_USE_PASSWORD_ONLY__1cxx9","kyc_external_check":"Statuses-module_kyc_external_check__MeSwQ","boarding":"Statuses-module_boarding__GyUJU","kyc_provided":"Statuses-module_kyc_provided__Z60MI","contract_pending":"Statuses-module_contract_pending__LP-o7","contract_generated":"Statuses-module_contract_generated__9lU-S","contract_provided":"Statuses-module_contract_provided__eF6im","contract_reviewed":"Statuses-module_contract_reviewed__tzWKa","reviewed":"Statuses-module_reviewed__4RD9r","validated":"Statuses-module_validated__Cyb3m","RECRYPTING":"Statuses-module_RECRYPTING__t88o3","completed":"Statuses-module_completed__oOK-H","PUBLIC":"Statuses-module_PUBLIC__9o7S4","anonymous":"Statuses-module_anonymous__YN0mm","re-boarding":"Statuses-module_re-boarding__Hiq9B","pre-boarding":"Statuses-module_pre-boarding__fmCNX","TAINTED":"Statuses-module_TAINTED__Uprxy","INVALID":"Statuses-module_INVALID__6vFdp","RESTRICTED":"Statuses-module_RESTRICTED__hDOIL","rejected":"Statuses-module_rejected__mXhHa","SUSPENDED":"Statuses-module_SUSPENDED__ZlASG"};

const isStatus = (tbd) => Object.keys(statuses).filter((c) => c === tbd).length > 0;
/**
 * Formats the different statuses
 */
const StatusFormatter = ({ value }) => {
    const styles = [style$5.status, value];
    if (isStatus(value)) {
        styles.push(statuses[value]);
    }
    return React.createElement("span", { className: styles.join(' ') }, value);
};

var style$4 = {"formatter":"TimeFrameFormatter-module_formatter__sH-DJ"};

const getDateTimeFromISOString = (input) => {
    const date = input.slice(0, 10);
    const time = input.slice(11, 19);
    return { date, time };
};
const getDateTimeFromNumber = (input) => {
    const date = new Date(input);
    return getDateTimeFromISOString(date.toISOString());
};
const getDateTimeFromString = (input) => {
    try {
        const date = new Date(Date.parse(input));
        return getDateTimeFromISOString(date.toISOString());
    }
    catch (e) {
        return { date: input, time: 'Invalid date' };
    }
};
/**
 * Formats a date and time value
 */
const TimeFrameFormatter = ({ value }) => {
    let dt;
    if (isString(value)) {
        dt = getDateTimeFromString(value);
    }
    else if (isNumber(value)) {
        dt = getDateTimeFromNumber(value);
    }
    if (undefined === dt) {
        return null;
    }
    const { date, time } = dt;
    return (React.createElement("span", { className: style$4.formatter, title: time }, date));
};

var style$3 = {"currency":"CurrencyFormatter-module_currency__uOAPi"};

/**
 * Formats the different Currencies
 */
const CurrencyFormatter = ({ value }) => {
    const styles = [style$3.currency, value];
    return (React.createElement("span", { className: styles.join(' '), style: { color: CurrencyColorProvider.getCurrencyColor(value) } }, value));
};

const ValueAsClassFormatter = ({ value }) => (React.createElement("span", { className: value, style: { margin: 'auto' } }, value));

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AmidFormatter: TunzMerchantIdFormatter,
    ButtonFormatter: ButtonFormatter,
    CurrencyFormatter: CurrencyFormatter,
    EditableFormatter: EditableFormatter,
    Inputs: index$1,
    LinkFormatter: LinkFormatter,
    LongTextFormatter: LongTextFormatter,
    MonetaryAmountFormatter: MonetaryAmountFormatter,
    MonetaryAmountFormatterNoPlusSign: MonetaryAmountFormatterNoPlusSign,
    MonetaryAmountFormatterNoPlusSignEUR: MonetaryAmountFormatterNoPlusSignEUR,
    MonetaryAmountFormatterNoSign: MonetaryAmountFormatterNoSign,
    MonetaryAmountFormatterNoSignEUR: MonetaryAmountFormatterNoSignEUR,
    MonetaryAmountFormatterToCustomise: MonetaryAmountFormatterToCustomise,
    NationalityFormatter: NationalityFormatter,
    NumberFormatter: NumberFormatter$1,
    PathToNameFormatter: PathToNameFormatter,
    PercentageFormatter: PercentageFormatter,
    StatusFormatter: StatusFormatter,
    TimeFrameFormatter: TimeFrameFormatter,
    TunzMerchantIdFormatter: TunzMerchantIdFormatter,
    ValueAsClassFormatter: ValueAsClassFormatter
});

var style$2 = {"paginationButtons":"PagedTable-module_paginationButtons__nxzcv","paginationButtonsContainer":"PagedTable-module_paginationButtonsContainer__Qmql-","iconRefreshAnimate":"PagedTable-module_iconRefreshAnimate__sfBt-","rotateThis":"PagedTable-module_rotateThis__iKagl"};

/**
 * remove useless props from RawTable
 * - loading => state handled inside PagedTable class via datasource & pagination
 */
const cleanProps = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _a = Object.assign({}, RawTable.defaultProps), others = __rest(_a, ["loading"]);
    return others;
};
const rawTablePropsClean = cleanProps();
/**
 * This component allows to define a table that is bound to a datasource
 * <b><i>PagedDataSource</i></b>.
 * It will automatically get the pages from the datasource and query it when changing pages.
 */
class PagedTable extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            currentRecords: [],
            loading: true,
            errorMessage: undefined,
        };
        this.setFilter = (column, fieldForInitialFilter, isCustomFilter = false) => {
            const { datasource, syncFiltersWithUrl } = this.props;
            const defaultValue = getDefaultValue(column, syncFiltersWithUrl, isCustomFilter);
            if (defaultValue) {
                datasource.setFilter(fieldForInitialFilter, defaultValue, column.filterType, false, typeof column.filtered === 'function' ? column.filtered : undefined, column);
            }
        };
        this.setLoading = (loading = true) => {
            this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { loading })));
        };
        this.getFirst = () => {
            const { datasource } = this.props;
            this.setLoading();
            datasource.getFirst();
        };
        this.getPrevious = () => {
            const { datasource } = this.props;
            this.setLoading();
            datasource.getPrevious();
        };
        this.getNext = () => {
            const { datasource } = this.props;
            this.setLoading();
            datasource.getNext();
        };
        this.getLast = () => {
            const { datasource } = this.props;
            this.setLoading();
            datasource.getLast();
        };
        this.getPageSizeSwitch = () => {
            const { datasource } = this.props;
            if (!datasource.getPaginator) {
                return null;
            }
            const pageSizes = datasource.getPaginator().getPossiblePageSizes();
            if (pageSizes.length === 0) {
                return null;
            }
            return (React.createElement(reactBootstrap.DropdownButton, { size: "sm", variant: "outline-secondary", title: datasource.getPaginator().getLabelForSize(datasource.getPageSize()), id: "changePageSize", onSelect: this.changePageSize, "data-testid": "pagesize-selector" }, pageSizes.map((s) => (React.createElement(reactBootstrap.Dropdown.Item, { key: s, eventKey: `${s}`, "data-testid": `pagesize-${s}` }, datasource.getPaginator().getLabelForSize(s))))));
        };
        this.reload = () => {
            const { datasource } = this.props;
            this.setLoading();
            datasource.getRowsForPage(true);
        };
        this.changePageSize = (sizeString) => {
            if (sizeString === null) {
                return;
            }
            const size = Number.parseInt(sizeString, 10);
            if (Number.isNaN(size)) {
                return;
            }
            const { datasource } = this.props;
            this.setLoading();
            datasource.setPageSize(size);
        };
        this.sortChanged = (field) => {
            const { datasource } = this.props;
            this.setLoading();
            datasource.setSorted(field);
        };
        this.filterData = (field, value) => {
            const { datasource, columns } = this.props;
            this.setLoading();
            const column = columns.find((c) => c.field === field);
            datasource.setFilter(field, value, column === null || column === void 0 ? void 0 : column.filterType, true, typeof (column === null || column === void 0 ? void 0 : column.filtered) === 'function' ? column === null || column === void 0 ? void 0 : column.filtered : undefined, column);
        };
        this.clearFilters = (fieldsToClear) => {
            this.setLoading();
            const { datasource, columns } = this.props;
            fieldsToClear.forEach((field) => {
                const column = columns.find((c) => c.field === field);
                let value = '';
                if (column) {
                    // Passing false to bypass what is in the url. otherwise nothing will be cleared
                    value = getDefaultValue(column, false) || '';
                }
                datasource.setFilter(field, value, undefined, true, undefined, column);
            });
        };
        this.rowsLoaded = (rows) => {
            this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { currentRecords: rows, loading: false, errorMessage: undefined })));
        };
        this.loadError = (error) => {
            this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { currentRecords: [], loading: false, errorMessage: error })));
        };
        this.colsWithSortInfo = () => {
            const { datasource, columns } = this.props;
            const sortInfo = datasource.getSortInfo();
            if (sortInfo.field) {
                const colsWithSortInfo = [...columns];
                colsWithSortInfo.forEach((e) => {
                    if (e.field !== sortInfo.field) {
                        e.sortOrder = exports.SortOrder.Undefined;
                    }
                    else {
                        e.sortOrder = sortInfo.order;
                    }
                });
                return colsWithSortInfo;
            }
            return columns;
        };
        this.renderHeader = () => {
            const { header } = this.props;
            return header && React.createElement("div", null, header);
        };
        this.renderPagination = () => {
            const { datasource } = this.props;
            const { loading } = this.state;
            return (React.createElement("div", { className: style$2.paginationButtonsContainer },
                React.createElement("div", { className: style$2.paginationButtons },
                    datasource.isReloadAllowed() && (React.createElement(React.Fragment, null,
                        React.createElement(reactBootstrap.Button, { size: "sm", variant: "outline-secondary", onClick: this.reload, title: "Reload data", "data-testid": "reloadButton" },
                            React.createElement(fa.FaSync, { className: loading ? `loading ${style$2.iconRefreshAnimate}` : undefined })),
                        "\u00A0")),
                    React.createElement(reactBootstrap.ButtonGroup, null,
                        React.createElement(reactBootstrap.Button, { size: "sm", variant: "outline-secondary", disabled: datasource.isFirst(), onClick: this.getFirst, title: "Go to first page", "data-testid": "firstPageButton" },
                            React.createElement(fa.FaStepBackward, null)),
                        React.createElement(reactBootstrap.Button, { size: "sm", variant: "outline-secondary", disabled: !datasource.hasPrevious(), onClick: this.getPrevious, title: "Go to next page", "data-testid": "previousPageButton" },
                            React.createElement(fa.FaBackward, null)),
                        React.createElement(reactBootstrap.Button, { size: "sm", variant: "outline-secondary", disabled: !datasource.hasNext(), onClick: this.getNext, title: "Go to next page", "data-testid": "nextPageButton" },
                            React.createElement(fa.FaForward, null)),
                        React.createElement(reactBootstrap.Button, { size: "sm", variant: "outline-secondary", disabled: datasource.isLast(), onClick: this.getLast, title: "Go to last page", "data-testid": "lastPageButton" },
                            React.createElement(fa.FaStepForward, null))),
                    "\u00A0",
                    this.getPageSizeSwitch(),
                    "\u00A0",
                    React.createElement("span", null, datasource.getSummary()))));
        };
    }
    componentDidMount() {
        const { datasource, columns, syncFiltersWithUrl } = this.props;
        // Register success and failure listeners once and for all
        datasource.registerDataChangedListener(this.rowsLoaded);
        datasource.registerErrorListener(this.loadError);
        datasource.syncFiltersWithUrl = syncFiltersWithUrl;
        // Set default sorting if one
        const columnsWithOrder = columns.filter((c) => c.sortOrder !== undefined && c.sortOrder !== 'none');
        if (columnsWithOrder.length > 0) {
            const { field, sortOrder, paramForOrderQuery } = columnsWithOrder[0];
            if (paramForOrderQuery !== undefined) {
                datasource.setSorted(paramForOrderQuery, sortOrder, false);
            }
            else {
                datasource.setSorted(field, sortOrder, false);
            }
        }
        // Set default filter if one
        const columnsWithFilter = columns.filter((c) => c.filtered === true || typeof c.filtered === 'function');
        if (columnsWithFilter.length > 0) {
            columnsWithFilter.forEach((column) => {
                const { field, paramForFilterQuery, customFilter } = column;
                this.setFilter(column, paramForFilterQuery || field);
                // Set filter twice if column has a custom filter that needs to be filtered from a URL param
                if (customFilter === null || customFilter === void 0 ? void 0 : customFilter.paramForFilterInUrl) {
                    this.setFilter(column, customFilter.paramForFilterInUrl, true);
                }
            });
        }
        this.reload();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (super.componentDidUpdate) {
            super.componentDidUpdate(prevProps, prevState, snapshot);
        }
        const { datasource } = this.props;
        if (datasource !== prevProps.datasource) {
            datasource.registerDataChangedListener(this.rowsLoaded);
            datasource.registerErrorListener(this.loadError);
            this.reload();
        }
    }
    componentWillUnmount() {
        const { datasource } = this.props;
        datasource.unregisterDataChangedListener(this.rowsLoaded);
        datasource.unregisterErrorListener(this.loadError);
    }
    render() {
        const { datasource, emptyMessage } = this.props;
        const { loading, currentRecords, errorMessage } = this.state;
        const tableHeader = (React.createElement("div", null,
            this.renderHeader(),
            this.renderPagination()));
        const errorDisplay = (React.createElement(reactBootstrap.Alert, { variant: "danger" },
            React.createElement("strong", null, " Error while loading data "),
            React.createElement("br", null),
            errorMessage));
        const columns = this.colsWithSortInfo();
        return (React.createElement(RawTable, Object.assign({}, this.props, { header: tableHeader, columns: columns, records: currentRecords, loading: loading, onSort: this.sortChanged, onFilter: this.filterData, onClearFilters: this.clearFilters, filterValues: datasource.filterInfo, onChildUpdate: this.reload, emptyMessage: 
            // eslint-disable-next-line no-nested-ternary
            errorMessage ? errorDisplay : loading ? 'Loading...' : emptyMessage })));
    }
}
PagedTable.defaultProps = Object.assign(Object.assign({}, rawTablePropsClean), { pageSizes: [], syncFiltersWithUrl: true, allowExport: true });

/**
 * The filter info is a helper class to keep track of filter value and type.
 */
class FilterInfo {
    /**
     * Creates a new FilterInfo.
     *
     * @param {value} value - The value of the filter.
     * @param {type} type - The type of the filter (optional).
     * @param {logic} logic - Custom filtering logic (optional).
     * @param {alternateNameInUrl} alternateNameInUrl - The name of the filter in the url (optional).
     */
    constructor(value, type = undefined, logic = undefined, alternateNameInUrl = undefined) {
        this.value = value;
        this.type = type;
        this.logic = logic;
        this.alternateNameInUrl = alternateNameInUrl;
    }
}

var _a;
class RangeFilterHelper {
    static isEmptyRange(from, to) {
        return !from && !to;
    }
}
_a = RangeFilterHelper;
RangeFilterHelper.isValueInRange = (value, range) => {
    const from = (range === null || range === void 0 ? void 0 : range.split('|')[0]) || '';
    const to = (range === null || range === void 0 ? void 0 : range.split('|')[1]) || '';
    if (_a.isEmptyRange(from, to)) {
        return true;
    }
    let isInRange = false;
    const fromNumber = from ? Number(from) : NaN;
    const toNumber = to ? Number(to) : NaN;
    if (!Number.isNaN(fromNumber) && Number.isNaN(toNumber)) {
        isInRange = Number(value) >= fromNumber;
    }
    else if (Number.isNaN(fromNumber) && !Number.isNaN(toNumber)) {
        isInRange = Number(value) <= toNumber;
    }
    else if (!Number.isNaN(fromNumber) && !Number.isNaN(toNumber)) {
        isInRange = Number(value) >= fromNumber && Number(value) <= toNumber;
    }
    return isInRange;
};

class BasePaginator {
    constructor(pageSize = 20, pageSizes = []) {
        this.pageSize = pageSize;
        this.startRow = 0;
        this.totalRecords = -1;
        this.pageSizes = pageSizes;
        this.hasMoreResults = false;
        this.recordsOnCurrentPage = 0;
    }
    hasNext() {
        return this.hasMoreResults;
    }
    isLast() {
        return !this.hasNext() || this.totalRecords === -1;
    }
    hasPrevious() {
        return this.startRow > 0;
    }
    isFirst() {
        return !this.hasPrevious();
    }
    firstPage() {
        this.startRow = 0;
    }
    getPageSize() {
        return this.pageSize;
    }
    getPageSizeForChart() {
        return this.getPageSize();
    }
    getPossiblePageSizes() {
        return this.pageSizes;
    }
    // eslint-disable-next-line class-methods-use-this
    getLabelForSize(size) {
        return `${size}`;
    }
    getSummary() {
        let lastShownRecord = this.startRow + this.pageSize;
        if (this.totalRecords !== -1 && lastShownRecord > this.totalRecords) {
            lastShownRecord = this.totalRecords;
        }
        else if (this.recordsOnCurrentPage < this.pageSize) {
            // last page
            lastShownRecord = this.startRow + this.recordsOnCurrentPage;
        }
        let summary = `${this.recordsOnCurrentPage > 0 ? this.startRow + 1 : 0} to ${lastShownRecord}`;
        if (this.totalRecords !== undefined && this.totalRecords !== -1) {
            summary = `${summary} - Total: ${this.totalRecords}`;
        }
        return summary;
    }
    lastPage() {
        this.startRow = this.totalRecords - (this.totalRecords % this.pageSize);
        if (this.startRow === this.totalRecords) {
            this.startRow = this.totalRecords - this.pageSize;
        }
    }
    nextPage() {
        this.startRow += this.pageSize;
    }
    previousPage() {
        this.startRow -= this.pageSize;
        if (this.startRow < 0) {
            this.startRow = 0;
        }
    }
    setPageSize(size) {
        this.pageSize = size;
    }
    setRecordsCount(total, currentPage) {
        this.totalRecords = total;
        if (this.totalRecords > this.startRow + this.pageSize) {
            this.hasMoreResults = true;
        }
        this.recordsOnCurrentPage = currentPage;
    }
    getTotalRecords() {
        return this.totalRecords;
    }
    // eslint-disable-next-line class-methods-use-this
    handleResults(results) {
        return results;
    }
    // eslint-disable-next-line class-methods-use-this
    addPaginationToUrl(url) {
        return url;
    }
    // eslint-disable-next-line class-methods-use-this
    defineUrlSeparator(url) {
        if (url.endsWith('?') || url.endsWith('&')) {
            return ''; // nothing to do
        }
        return url.includes('?')
            ? '&' // prepare for more key=value pairs
            : '?'; // start of query string
    }
}

function functionDelay(func, waitTimeInMillis) {
    let timeId;
    return (...args) => {
        clearTimeout(timeId);
        timeId = setTimeout(() => {
            func(...args);
        }, waitTimeInMillis);
    };
}

class PagedDataSource {
    constructor(paginator = new BasePaginator()) {
        this.start = 0;
        this.size = 0;
        this.dataChangedListeners = [];
        this.errorListeners = [];
        this.syncFiltersWithUrl = true;
        this.getCurrentRecords = () => this.currentRecords;
        this.getPageSize = () => this.paginator.getPageSize();
        this.getTotalRecords = () => this.paginator.getTotalRecords();
        this.setPageSize = (pageSize, autoFetch = true) => {
            this.paginator.setPageSize(pageSize);
            if (autoFetch) {
                this.getFirst();
            }
        };
        this.getFirst = () => {
            this.paginator.firstPage();
            this.getRowsForPage();
        };
        this.isFirst = () => this.paginator.isFirst();
        this.getPrevious = () => {
            this.paginator.previousPage();
            this.getRowsForPage();
        };
        this.hasPrevious = () => this.paginator.hasPrevious();
        this.getNext = () => {
            this.paginator.nextPage();
            this.getRowsForPage();
        };
        this.hasNext = () => this.paginator.hasNext();
        this.isLast = () => this.paginator.isLast();
        this.getLast = () => {
            this.paginator.lastPage();
            this.getRowsForPage();
        };
        this.getPaginator = () => this.paginator;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.getRowsForPage = (forceReload = false) => {
            const removeExtraRow = (data) => {
                this.currentRecords = this.paginator.handleResults(data);
                this.notifySuccess(this.currentRecords);
            };
            return this.getRows(removeExtraRow, this.notifyError);
        };
        // eslint-disable-next-line class-methods-use-this
        this.getRows = (successCallback, failureCallback) => {
            // eslint-disable-next-line no-console
            console.error('Unable to get Rows. Please use a specific data source');
            failureCallback('Implement the getRows function');
            throw new Error('Implement the getRows function');
        };
        this.setSorted = (field, direction, autoFetch = true) => {
            if (direction) {
                this.sortInfo = new SortInfo(field, direction);
            }
            else {
                this.sortInfo.update(field);
            }
            if (autoFetch) {
                this.getFirst();
            }
        };
        this.getSortInfo = () => this.sortInfo;
        this.getAutoFetchFunction = () => {
            if (this.shouldDelayFilter()) {
                return functionDelay(this.getFirst, 600);
            }
            return this.getFirst;
        };
        this.setFilter = (field, value, type = undefined, autoFetch = true, filterLogic = undefined, column = undefined) => {
            this.setFilterInfo(field, value, type, filterLogic, column);
            if (autoFetch) {
                this.getAutoFetchFunction()();
            }
        };
        this.registerDataChangedListener = (listener) => {
            if (!this.dataChangedListeners.includes(listener)) {
                this.dataChangedListeners.push(listener);
            }
        };
        this.unregisterDataChangedListener = (listener) => {
            this.dataChangedListeners = this.dataChangedListeners.filter((l) => l !== listener);
        };
        this.notifySuccess = (rows) => {
            this.dataChangedListeners.forEach((l) => l(rows));
        };
        this.registerErrorListener = (listener) => {
            if (!this.errorListeners.includes(listener)) {
                this.errorListeners.push(listener);
            }
        };
        this.unregisterErrorListener = (listener) => {
            this.errorListeners = this.errorListeners.filter((l) => l !== listener);
        };
        this.notifyError = (message) => {
            this.errorListeners.forEach((l) => l(message));
        };
        this.isMatchingFilter = (record) => {
            let matches = true;
            this.filterInfo.forEach((fi, k) => {
                if (fi.type === 'rangeFilter') {
                    matches = RangeFilterHelper.isValueInRange(String(record[k]), fi.value);
                }
                else if (fi.logic !== undefined) {
                    if (!fi.logic(record[k], fi.value)) {
                        matches = false;
                    }
                }
                else if (fi.value) {
                    if (fi.type === 'dropDownList') {
                        if (String(record[k]).toLocaleLowerCase() !== fi.value.toLocaleLowerCase()) {
                            matches = false;
                        }
                    }
                    else if (!String(record[k]).toLocaleLowerCase().includes(fi.value.toLocaleLowerCase())) {
                        matches = false;
                    }
                }
            });
            return matches;
        };
        // eslint-disable-next-line class-methods-use-this
        this.isReloadAllowed = () => true;
        // eslint-disable-next-line class-methods-use-this
        this.shouldDelayFilter = () => true;
        this.paginator = paginator;
        this.sortInfo = new SortInfo();
        this.currentRecords = [];
        this.filterInfo = new Map();
    }
    getSummary() {
        return this.paginator.getSummary();
    }
    setFilterInfo(field, value, type, filterLogic, column) {
        if (field && field.length > 0) {
            this.filterInfo.delete(field);
            this.filterInfo.set(field, new FilterInfo(value, type, filterLogic, getFilterNameInUrl(column)));
        }
        else {
            this.filterInfo = new Map();
        }
        this.syncFilterInfoWithUrl();
    }
    syncFilterInfoWithUrl() {
        if (this.syncFiltersWithUrl) {
            const urlSearchParams = new URLSearchParams(getSearch());
            this.filterInfo.forEach((filter, field) => {
                if (filter.value && filter.value.length > 0) {
                    urlSearchParams.set(filter.alternateNameInUrl || field, filter.value);
                }
                else {
                    urlSearchParams.delete(filter.alternateNameInUrl || field);
                }
            });
            pushSearch(urlSearchParams);
        }
    }
}

const isError = (object) => 'msg' in object;

const loadRemoteData = (url, additionalHeaders = {}) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield http.HttpClient.get(url, {
            withCredentials: true,
            headers: Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, additionalHeaders),
        });
        const answer = response.data;
        if (isError(answer)) {
            throw new Error(answer.msg);
        }
        return answer;
    }
    catch (error) {
        if (error.response) {
            const { status, data } = error.response;
            const reason = typeof data === 'string' ? data : JSON.stringify(data);
            if (status === 403) {
                throw new Error(`You are not allowed to perform this action. Please try to login again or contact your administrator: ${reason}`);
            }
            if (status === 401) {
                throw new Error(`Your session has expired. Please login again: ${reason}`);
            }
            throw new Error(`Unexpected error : ${status} ${reason}`);
        }
        else {
            throw new Error(`${error.message}`);
        }
    }
});

class NumberRemotePaginator extends BasePaginator {
    constructor(pageSize = 20, pageSizes = [], startUrlLabel = 'start', numberUrlLabel = 'number') {
        super(pageSize, pageSizes);
        this.startUrlLabel = startUrlLabel;
        this.numberUrlLabel = numberUrlLabel;
    }
    addPaginationToUrl(url) {
        const enc = encodeURIComponent;
        const separator = this.defineUrlSeparator(url);
        // load pageSize + 1 records to check if there is next page to load
        const numberOfRecordsToLoad = this.pageSize + 1;
        return `${url}${separator}${this.startUrlLabel}=${enc(this.startRow)}&${this.numberUrlLabel}=${enc(numberOfRecordsToLoad)}`;
    }
    handleResults(results) {
        // pageSize + 1 records was loaded to check if there is next page to load
        this.hasMoreResults = results.length > this.pageSize;
        if (this.hasMoreResults) {
            return results.slice(0, this.pageSize);
        }
        return results;
    }
}

/**
 * This class implements a data source that connects to a TUNZ REST service
 * The pagination is automatically handled according to the TUNZ way of working on the server
 *
 * Usage: const datasource = new RemoteDataSource(URL);
 */
class RemoteDataSource extends PagedDataSource {
    constructor(url, paginator = new NumberRemotePaginator(), additionalHeaders = {}) {
        super(paginator);
        this.getRows = (successCallback, failureCallback) => __awaiter(this, void 0, void 0, function* () {
            const reportError = (errMsg) => failureCallback && failureCallback(errMsg);
            const reportSuccess = (answer) => successCallback ? successCallback(answer) : reportError('Missing Success cb');
            try {
                const resJson = yield loadRemoteData(this.buildFullQueryURL(), this.additionalHeaders);
                if (Array.isArray(resJson)) {
                    this.currentRecords = resJson;
                    this.paginator.setRecordsCount(-1, this.currentRecords.length); // Degraded pagination
                }
                else if (Array.isArray(resJson.data)) {
                    const apiResponse = resJson;
                    this.currentRecords = apiResponse.data;
                    this.paginator.setRecordsCount(apiResponse.recordsTotal, this.currentRecords.length);
                }
                else {
                    return reportError(`Unable to get array answer from ${this.url}. Got : ${JSON.stringify(resJson)}`);
                }
                return reportSuccess(this.currentRecords);
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.trace(error);
                return reportError(error.message);
            }
        });
        /**
         * Build the full query URL taking filter and sorting info into account
         * @returns {string}
         */
        this.buildFullQueryURL = () => {
            const enc = encodeURIComponent;
            let queryUrl = this.paginator.addPaginationToUrl(this.url);
            // Add filtering info
            this.filterInfo.forEach((fi, k) => {
                if (fi.value !== undefined) {
                    const trimmedValue = fi.value.trim();
                    if (trimmedValue !== '*' && trimmedValue !== '|' && trimmedValue !== '') {
                        // When a wildcard is selected in a dropdown, just ignore it
                        const sep = this.paginator.defineUrlSeparator(queryUrl);
                        queryUrl += `${sep}${enc(k)}=${enc(trimmedValue)}`;
                    }
                }
            });
            // Add sorting info
            const { field, order } = this.sortInfo;
            if (field && order !== exports.SortOrder.Undefined) {
                const sep = this.paginator.defineUrlSeparator(queryUrl);
                queryUrl += `${sep}order_column=${enc(field)}&order_direction=${enc(order)}`;
            }
            return queryUrl;
        };
        this.url = url;
        this.additionalHeaders = additionalHeaders;
    }
}

const compareFields = (a, b, field, dir) => {
    if (a[field] === b[field]) {
        return 0;
    }
    return a[field] > b[field] ? dir : -dir;
};
class LocalSorting {
}
LocalSorting.sort = (rows, field, order) => {
    let dir = 0;
    dir = order === exports.SortOrder.Asc ? 1 : dir;
    dir = order === exports.SortOrder.Desc ? -1 : dir;
    return field && dir !== 0
        ? [...rows].sort((a, b) => compareFields(a, b, field, dir))
        : rows;
};

/**
 * This class implements a data source that connects to a TUNZ REST service
 * Filtering and sorting is done in the browser
 */
class SemiRemoteDataSource extends RemoteDataSource {
    constructor(url, paginator = new NumberRemotePaginator(), additionalHeaders = {}) {
        super(url, paginator, additionalHeaders);
        this.setFilter = (field, value, type = undefined, autoFetch = true, filterLogic = undefined, column = undefined) => {
            this.setFilterInfo(field, value, type, filterLogic, column);
            if (autoFetch) {
                this.notifySuccess(this.applyFilterAndSort(this.currentRecords));
            }
        };
        this.setSorted = (field, direction) => {
            if (direction) {
                this.sortInfo = new SortInfo(field, direction);
            }
            else {
                this.sortInfo.update(field);
            }
            this.notifySuccess(this.applyFilterAndSort(this.currentRecords));
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.getRowsForPage = (forceReload = false) => this.getRows((rows) => this.notifySuccess(this.applyFilterAndSort(this.paginator.handleResults(rows))), this.notifyError);
        this.applyFilterAndSort = (rows) => {
            // filter
            let filteredRecords = [];
            rows.forEach((record) => {
                if (this.isMatchingFilter(record)) {
                    filteredRecords.push(record);
                }
            });
            // sort
            const { field, order } = this.sortInfo;
            if (field) {
                filteredRecords = LocalSorting.sort(filteredRecords, field, order);
            }
            return filteredRecords;
        };
        // eslint-disable-next-line class-methods-use-this
        this.shouldDelayFilter = () => false;
    }
}

class NumberLocalPaginator extends BasePaginator {
    handleResults(results) {
        this.totalRecords = results.length;
        this.hasMoreResults = results.length - this.startRow > this.pageSize;
        const currentPage = results.slice(this.startRow, this.startRow + this.pageSize);
        this.recordsOnCurrentPage = currentPage.length;
        return currentPage;
    }
}

/**
 * This datasource gets all the records in the constructor (no network call at all) and handles
 * pagination, sorting and filtering in the browser.
 * This is handy if you already have the records from another source
 */
class LocalDataSource extends PagedDataSource {
    constructor(data, paginator = new NumberLocalPaginator()) {
        super(paginator);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.getRowsForPage = (forceReload = false) => this.getRows(this.notifySuccess, this.notifyError);
        this.getRows = (successCallback, failureCallback) => __awaiter(this, void 0, void 0, function* () {
            try {
                let workingData = [...this.data];
                if (this.sortInfo && this.sortInfo.field) {
                    workingData = LocalSorting.sort(workingData, this.sortInfo.field, this.sortInfo.order);
                }
                if (this.filterInfo) {
                    workingData = workingData.filter((d) => this.isMatchingFilter(d));
                }
                this.currentRecords = this.paginator.handleResults(workingData);
                successCallback(this.currentRecords);
            }
            catch (e) {
                failureCallback(e.message);
            }
        });
        // eslint-disable-next-line class-methods-use-this
        this.isReloadAllowed = () => false;
        // eslint-disable-next-line class-methods-use-this
        this.shouldDelayFilter = () => false;
        this.data = data;
    }
}

/**
 * This class retrieve all data at once and handle pagination, sorting and filtering on device
 */
class FetchAllDataSource extends LocalDataSource {
    constructor(url, paginator = new NumberLocalPaginator(), additionalHeaders = {}) {
        super([], paginator);
        this.getDataFromServer = () => __awaiter(this, void 0, void 0, function* () {
            const answer = yield loadRemoteData(this.url, this.additionalHeaders);
            if (Array.isArray(answer)) {
                return answer;
            }
            if (Array.isArray(answer.data)) {
                return answer.data;
            }
            throw new Error(`Unable to get array answer from ${this.url}. Got : ${JSON.stringify(answer)}`);
        });
        this.getRowsForPage = (forceReload = false) => __awaiter(this, void 0, void 0, function* () {
            if (forceReload) {
                try {
                    this.data = yield this.getDataFromServer();
                }
                catch (e) {
                    this.notifyError(e.message);
                    return undefined;
                }
            }
            return this.getRows(this.notifySuccess, this.notifyError);
        });
        // eslint-disable-next-line class-methods-use-this
        this.isReloadAllowed = () => true;
        // eslint-disable-next-line class-methods-use-this
        this.shouldDelayFilter = () => false;
        this.url = url;
        this.additionalHeaders = additionalHeaders;
    }
}

const defaultDurations = [
    { amount: 1, unit: 'MONTHS' },
    { amount: 2, unit: 'MONTHS' },
    { amount: 6, unit: 'MONTHS' },
    { amount: 1, unit: 'YEARS' },
    { amount: 5, unit: 'YEARS' },
];
const extractIndexes = (durations) => Object.keys(durations).map((d) => Number.parseInt(d, 10));
/**
 * Returns a date for a duration unit.
 * For instance, considering today as 2023-09-21,
 * the returned from-to dates per range are the followings:
 * 1 day: 2023-09-21 00:00:00.000 -> 2023-09-21 23:59:59.999
 * 1 month: 2023-08-22 00:00:00.000 -> 2023-09-21 23:59:59.999
 * 1 year: 2022-09-22 00:00:00.000 -> 2023-09-21 23:59:59.999
 * Default start date = today
 * Supports dynamic starting date
 */
const getDate = (multiplier, duration, endOfPreviousDay = false, startDate = new Date()) => {
    const date = new Date(startDate.getTime()); // Create a copy of startDate (pass by reference)
    date.setUTCHours(24, 0, 0, 0); // tomorrow midnight
    switch (duration.unit) {
        case 'DAYS':
            date.setDate(date.getDate() - multiplier * duration.amount);
            break;
        case 'MONTHS':
            date.setMonth(date.getMonth() - multiplier * duration.amount);
            break;
        case 'YEARS':
        default:
            date.setFullYear(date.getFullYear() - multiplier * duration.amount);
            break;
    }
    date.setMilliseconds(date.getMilliseconds() - +endOfPreviousDay);
    return date;
};
const getFormattedDate = (multiplier, duration, endOfPreviousDay = false, startDate = undefined) => getDate(multiplier, duration, endOfPreviousDay, startDate).toISOString().substring(0, 10);
class DateRemotePaginator extends BasePaginator {
    constructor(durations = defaultDurations, fromUrlLabel = 'from', toUrlLabel = 'to', defaultDurationIndex = 0, startDate = undefined) {
        // In this implementation, the sizes are the indexes of the durations
        super(defaultDurationIndex, extractIndexes(durations));
        this.getDurationForIndex = (index) => {
            let duration = this.durations[index];
            if (!duration) {
                // eslint-disable-next-line prefer-destructuring
                duration = this.durations[0];
            }
            return duration;
        };
        this.getToDate = () => getFormattedDate(this.startRow, this.getDurationForIndex(this.pageSize), true, this.startDate);
        this.getFromDate = () => getFormattedDate(this.startRow + 1, this.getDurationForIndex(this.pageSize), false, this.startDate);
        this.getLabelForSize = (size) => {
            const duration = this.getDurationForIndex(size);
            let displayedUnit = duration.unit.toLowerCase();
            // Remove s from unit if amount is 1
            if (duration.amount === 1) {
                displayedUnit = displayedUnit.substring(0, displayedUnit.length - 1);
            }
            return `${duration.amount} ${displayedUnit}`;
        };
        this.addPaginationToUrl = (url) => {
            const enc = encodeURIComponent;
            const from = this.getFromDate();
            const to = this.getToDate();
            const separator = this.defineUrlSeparator(url);
            return `${url}${separator}${this.fromUrlLabel}=${enc(from)}&${this.toUrlLabel}=${enc(to)}`;
        };
        this.getSummary = () => `from ${this.getFromDate()} to ${this.getToDate()}`;
        // eslint-disable-next-line class-methods-use-this
        this.isFirst = () => true; // disable the button
        // eslint-disable-next-line class-methods-use-this
        this.hasPrevious = () => true; // enable the button
        this.hasNext = () => this.startRow !== 0;
        this.isLast = () => this.startRow === 0;
        this.durations = durations;
        this.fromUrlLabel = fromUrlLabel;
        this.toUrlLabel = toUrlLabel;
        this.startDate = startDate;
    }
    getPageSizeForChart() {
        const duration = this.getDurationForIndex(this.pageSize);
        const fromDate = getDate(this.startRow + 1, duration, false, this.startDate);
        const toDate = getDate(this.startRow, duration, true, this.startDate);
        // returns nb of days between the 2 dates
        return Math.round((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24));
    }
    nextPage() {
        this.startRow -= 1;
    }
    previousPage() {
        this.startRow += 1;
    }
    lastPage() {
        this.startRow = 0;
    }
    // eslint-disable-next-line class-methods-use-this
    handleResults(results) {
        return results;
    }
}

/**
 * @deprecated Use RemoteDataSource
 */
class PagedRestDataSource extends RemoteDataSource {
    constructor(url, pageSize = 20, additionalHeaders = {}) {
        super(url, new NumberRemotePaginator(pageSize), additionalHeaders);
    }
}

/**
 * @deprecated Use RemoteDataSource with a DateRemotePaginator
 */
class DateRangeRestDataSource extends RemoteDataSource {
    constructor(url, pageSize, additionalHeaders = {}) {
        super(url, new DateRemotePaginator(), additionalHeaders);
    }
}

/**
 * @deprecated Use FetchAllDataSource
 */
class LocalPaginationDataSource extends FetchAllDataSource {
    constructor(url, pageSize = 20, additionalHeaders = {}) {
        super(url, new NumberLocalPaginator(pageSize), additionalHeaders);
    }
}

/**
 * Simple data displayer
 * Displays data in a table form based on field definitions passed as props
 *
 */
const DataDisplayer = ({ data, fieldDefinitions, title = 'test' }) => (React.createElement("div", { className: style$g.tableWrapper },
    React.createElement(reactBootstrap.Table, { size: "sm", hover: true },
        title && (React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", { colSpan: 2 },
                    React.createElement("b", null, title))))),
        React.createElement("tbody", null, fieldDefinitions.map((fd) => (React.createElement("tr", { key: fd.field },
            React.createElement("td", null,
                React.createElement("b", null, fd.name)),
            React.createElement("td", null, fd.renderer ? (React.createElement(CellErrorBoundary, null, React.createElement(fd.renderer, {
                value: data[fd.field],
                record: data,
            }))) : (data[fd.field])))))))));

/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
const EditStringFormatter = ({ column, data, onEditEnd, onValidate, }) => (React.createElement(TextInput, { value: data.value, name: column !== undefined && column.name !== undefined ? column.name : data.key, onEditEnd: onEditEnd, onChange: onValidate, "data-testid": `edit-record-detail-${data.key}` }));
/**
 * Displays the detail of an object (key - value) in a table format.
 * This can be easily used as detail of a row in another table.
 */
class EditRecordDetail extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            record: this.props.record,
        };
    }
    setRecordValue(key, val) {
        const { record } = this.state;
        const { onEditEnd } = this.props;
        record[key] = val;
        this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { record })));
        onEditEnd(record);
    }
    render() {
        const { columns } = this.props;
        const { record } = this.state;
        const recordValues = Object.keys(record).map((k) => ({
            key: k,
            value: record[k],
        }));
        const rows = [
            columns
                .filter((col) => !col.hidden)
                .map((column) => {
                const renderer = column.renderer || EditStringFormatter;
                const c = recordValues.find((rv) => rv.key === column.field);
                if (c !== undefined) {
                    return (React.createElement(CellErrorBoundary, { key: `row-${c.key}` }, React.createElement(renderer, {
                        column,
                        data: c,
                        onValidate: column.onValidate,
                        onEditEnd: (v) => this.setRecordValue(c.key, v),
                    })));
                }
                return null;
            }),
        ];
        return React.createElement(reactBootstrap.Form, null, rows);
    }
}
EditRecordDetail.defaultProps = {
    record: {},
    columns: {},
    onEditEnd: () => undefined,
};

/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/**
 * EditRecord panel - allows to edit one record with columns described in props.
 */
class EditRecord extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            show: true,
            record: this.props.record,
        };
        this.onEditEnd = (record) => {
            this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { record })));
        };
        this.cancel = () => {
            this.hide();
            this.props.onCancel();
        };
        this.confirm = () => {
            const { record } = this.state;
            this.hide();
            this.props.onConfirm(record);
        };
        this.hide = () => this.setState({ show: false });
    }
    render() {
        const { record, columns, title, confirmLabel, cancelLabel, enableEscape } = this.props;
        const { show } = this.state;
        return (React.createElement("div", { className: "static-modal" },
            React.createElement(reactBootstrap.Modal, { show: show, backdrop: enableEscape ? true : 'static', keyboard: enableEscape, animation: false },
                React.createElement(reactBootstrap.Modal.Header, null,
                    React.createElement(reactBootstrap.Modal.Title, null, title)),
                React.createElement(reactBootstrap.Modal.Body, null,
                    React.createElement(EditRecordDetail, { record: record, columns: columns, onEditEnd: this.onEditEnd })),
                React.createElement(reactBootstrap.Modal.Footer, null,
                    React.createElement(reactBootstrap.Button, { variant: "outline-secondary", onClick: this.cancel, "data-testid": "editRecord-cancel" }, cancelLabel),
                    React.createElement(reactBootstrap.Button, { className: "button-l", variant: "primary", onClick: this.confirm, "data-testid": "editRecord-confirm" }, confirmLabel)))));
    }
}
EditRecord.defaultProps = {
    record: undefined,
    columns: [],
    title: 'Edit Record',
    confirmLabel: 'Save',
    cancelLabel: 'Cancel',
    enableEscape: true,
    onConfirm: () => undefined,
    onCancel: () => undefined,
    onDismiss: () => undefined,
};
const edit = (record, columns, title = 'Edit', mountingNode = document.body) => {
    const divElement = document.createElement('div');
    const wrapper = mountingNode.appendChild(divElement);
    const root = client.createRoot(wrapper);
    const dispose = () => {
        root.unmount();
        mountingNode.removeChild(wrapper);
    };
    const promise = new Promise((resolve, reject) => {
        root.render(React.createElement(EditRecord, { onConfirm: resolve, onCancel: reject, onDismiss: dispose, record: record, columns: columns, title: title }));
    });
    return promise.then((r) => Promise.resolve(r), () => {
        dispose();
        return Promise.reject();
    });
};

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const DATA_KEY = 'ts';
class DateHelper {
    static getDatesBetweenDates(startDate, endDate) {
        const dates = [];
        let cur = startDate;
        while (cur <= endDate) {
            dates.push(cur);
            cur += DAY_IN_MS;
        }
        return dates;
    }
    static dateToDateFormatterFromTs(ts) {
        return new Date(ts);
    }
    static dateToReadableFormatterFromTs(ts) {
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        };
        return DateHelper.dateToDateFormatterFromTs(ts).toLocaleDateString('en', options);
    }
}

class GraphDataHelper {
    constructor(dateField, dimensions, keyGetter, valueGetter) {
        this.dateField = dateField;
        this.dimensions = dimensions;
        this.keyGetter = keyGetter;
        this.valueGetter = valueGetter;
        this.makeGraphable = this.makeGraphable.bind(this);
    }
    makeGraphable(graphData) {
        let minDate = new Date().getTime();
        let maxDate = 0;
        const tmp = new Map();
        const keyMap = new Map();
        graphData.forEach((entry) => {
            const ts = Date.parse(entry[this.dateField].split('T')[0].split(' ')[0]);
            const map = GraphDataHelper.getOrCreateMapPerDate(ts, tmp);
            this.dimensions.forEach((dimension) => {
                const keyInfo = this.keyGetter(entry);
                const key = this.dimensions.length > 1 ? `${dimension} ${keyInfo.key}` : `${keyInfo.key}`;
                keyMap.set(key, {
                    dimension,
                    extractedFields: keyInfo.extractedFields,
                });
                map.set(key, this.valueGetter(entry, dimension));
            });
            // define ts boundaries
            if (ts < minDate) {
                minDate = ts;
            }
            if (ts > maxDate) {
                maxDate = ts;
            }
        });
        // fill gaps in data array (only if it makes sense)
        if (graphData.length > 0) {
            const dateRange = DateHelper.getDatesBetweenDates(minDate, maxDate);
            dateRange.forEach((ts) => {
                const values = GraphDataHelper.getOrCreateMapPerDate(ts, tmp);
                keyMap.forEach((value, key) => {
                    if (!values.has(key)) {
                        values.set(key, 0);
                    }
                });
            });
        }
        let dataToGraph = [];
        tmp.forEach((values, ts) => {
            const graphValues = {};
            values.forEach((value, key) => {
                graphValues[key] = value;
            });
            dataToGraph.push(Object.assign({ ts }, graphValues));
        });
        dataToGraph = GraphDataHelper.sort(dataToGraph, 'ts', exports.SortOrder.Asc);
        return {
            keyMap,
            dataToGraph,
        };
    }
    static getOrCreateMapPerDate(ts, globalMap) {
        if (!globalMap.has(ts)) {
            globalMap.set(ts, new Map());
        }
        return globalMap.get(ts) || new Map();
    }
    static sort(rows, field, order) {
        let dir = 0;
        dir = order === exports.SortOrder.Asc ? 1 : dir;
        dir = order === exports.SortOrder.Desc ? -1 : dir;
        if (field && dir !== 0) {
            const sortedRecords = rows.slice().sort((a, b) => {
                if (a[field] === b[field]) {
                    return 0;
                }
                return a[field] > b[field] ? dir : -dir;
            });
            return sortedRecords;
        }
        return rows;
    }
}

const KEY_SEP = '-';
class KeyHelper {
    static toKeyElement(fieldValue, appendSeparator = true) {
        const sep = appendSeparator ? KEY_SEP : '';
        return fieldValue === '*' ? '' : `${fieldValue}${sep}`;
    }
}

const ZoomOutButton = ({ zoomed, onClick }) => (React.createElement("button", { type: "button", className: zoomed ? 'btn zoomOut zoomed' : 'btn zoomOut notZoomed', onClick: onClick }, "Zoom Out"));

class AxisHelper {
    static helperForTickInterval(paginator, defaultInterval = 10) {
        const pageSizeForChart = paginator.getPageSizeForChart();
        if (pageSizeForChart <= defaultInterval) {
            return 1;
        }
        return Math.round(pageSizeForChart / defaultInterval);
    }
}

/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unstable-nested-components */
const initialState = [];
const SimpleTimeLineChart = (props) => {
    const [zoomed, setZoomed] = React.useState(false);
    const [dataToGraphBackUp, setDataToGraphBackUp] = React.useState(initialState);
    const [dataToGraph, setDataToGraph] = React.useState(initialState);
    const [keyMap, setKeyMap] = React.useState(new Map());
    const [left, setLeft] = React.useState('dataMin');
    const [right, setRight] = React.useState('dataMax');
    const [refAreaLeft, setRefAreaLeft] = React.useState('');
    const [refAreaRight, setRefAreaRight] = React.useState('');
    const { datasource, dataConvertFunction, dimensions, title = '', header = undefined, getColorFromKey = () => '#000000', renderWithCurrentDataTrigger = undefined, formatValue = (value) => value, labelForXAxis = '', customGraphSize = undefined, useAngleForXAxisLabel = false, } = props;
    const getDataSubset = (from, to) => {
        const dataSubset = [];
        dataToGraph.forEach((record) => {
            // ignore rows out of selected range
            if (record.ts >= from && record.ts <= to) {
                dataSubset.push(record);
            }
        });
        return dataSubset;
    };
    const setZoomVariables = (data, newL, newR, isZoomed) => {
        setDataToGraph(data);
        setRefAreaLeft('');
        setRefAreaRight('');
        setLeft(newL);
        setRight(newR);
        setZoomed(isZoomed);
    };
    const yLabel = (dimension) => {
        const position = dimension.isLeftYAxis ? 'left' : 'right';
        const offset = dimension.isLeftYAxis ? 0 : 10;
        const translate = dimension.isLeftYAxis ? '-20px 15px' : '10px -60px';
        const writingMode = dimension.isLeftYAxis ? 'vertical-lr' : 'vertical-rl';
        return (React.createElement(recharts.Label, { value: dimension.axisLabel, position: position, style: {
                border: '1px solid red',
                backgroundColor: 'red',
                margin: '10px',
                writingMode,
                translate,
            }, offset: offset }));
    };
    const isLabelSet = (mouse) => mouse && !!mouse.activeLabel;
    const onMouseDown = (mouse) => {
        // ignore click outside of the graph zone
        if (isLabelSet(mouse)) {
            if (!refAreaLeft) {
                setRefAreaLeft(mouse.activeLabel || '');
            }
            else {
                // maybe the mouse is back in the zone while a zoom was initiated
                setRefAreaRight(mouse.activeLabel || '');
            }
        }
    };
    const onMouseMove = (mouse) => {
        // ignore move outside the graph zone and when no zoom was initiated
        if (isLabelSet(mouse) && refAreaLeft) {
            setRefAreaRight(mouse.activeLabel || '');
        }
    };
    const zoom = () => {
        // clicked but no move : no area selected ?
        if (refAreaLeft === refAreaRight || refAreaRight === '') {
            // reset zoom area
            setRefAreaLeft('');
            setRefAreaRight('');
            // do nothing
            return;
        }
        let lRefAreaLeft = refAreaLeft;
        let lRefAreaRight = refAreaRight;
        if (refAreaLeft > refAreaRight) {
            // these refs could be inverted
            lRefAreaLeft = refAreaRight;
            lRefAreaRight = refAreaLeft;
        }
        const l = Number.parseInt(lRefAreaLeft, 10);
        const r = Number.parseInt(lRefAreaRight, 10);
        const dataSubset = getDataSubset(l, r);
        setZoomVariables(dataSubset, lRefAreaLeft, lRefAreaRight, true);
    };
    const zoomOut = () => {
        setZoomVariables(dataToGraphBackUp, 'dataMin', 'dataMax', false);
    };
    const dataChangedListener = (rows) => {
        try {
            const result = dataConvertFunction(rows);
            setDataToGraphBackUp(result.dataToGraph);
            setDataToGraph(result.dataToGraph);
            setKeyMap(result.keyMap);
            // reset potential zoom, using new data
            setZoomVariables(result.dataToGraph, 'dataMin', 'dataMax', false);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    };
    React.useEffect(() => {
        datasource.registerDataChangedListener(dataChangedListener);
        return () => {
            datasource.unregisterDataChangedListener(dataChangedListener);
        };
    }, []);
    // allow different display of the charts with already loaded data
    React.useEffect(() => {
        dataChangedListener(datasource.getCurrentRecords());
    }, [renderWithCurrentDataTrigger]);
    const formatter = new Intl.NumberFormat(undefined, {
        maximumFractionDigits: 20, // Maximum allowed by the documentation
    });
    const getStrokeDasharray = (dimension) => {
        if (dimensions[dimension].strokeDasharray) {
            if (dimensions[dimension].strokeDasharray === 'noDash') {
                return undefined;
            }
            return dimensions[dimension].strokeDasharray;
        }
        return dimensions[dimension].isLeftYAxis
            ? undefined // = no dash
            : '7 7';
    };
    const getStrokeWidth = (dimension) => {
        if (dimensions[dimension].strokeWidth) {
            return dimensions[dimension].strokeWidth;
        }
        return 1;
    };
    // eslint-disable-next-line react/jsx-no-useless-fragment
    const renderHeader = () => header && React.createElement(React.Fragment, null, header);
    return (React.createElement("div", { id: "graphWrapper", "data-testid": "graph_wrapper" },
        React.createElement("h3", { className: "graphTitle" }, title),
        React.createElement(ZoomOutButton, { onClick: zoomOut, zoomed: zoomed }),
        renderHeader(),
        dataToGraph.length > 0 ? (React.createElement(recharts.ResponsiveContainer, { id: "graphResponsiveContainer", className: "flex-child", width: customGraphSize ? customGraphSize.width : '100%', height: customGraphSize ? customGraphSize.height : '90%', debounce: 300 },
            React.createElement(recharts.LineChart, { id: "simpleTimeLineChart", data: dataToGraph, margin: {
                    top: 5,
                    right: 100,
                    left: 40,
                    bottom: 5,
                }, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseUp: zoom },
                React.createElement(recharts.CartesianGrid, { strokeDasharray: "5 5" }),
                React.createElement(recharts.XAxis, { allowDataOverflow: true, dataKey: DATA_KEY, domain: [left, right], type: "number", scale: "time", interval: AxisHelper.helperForTickInterval(datasource.getPaginator()), tickFormatter: DateHelper.dateToReadableFormatterFromTs, label: { value: `${labelForXAxis}`, position: 'bottom', offset: -7 }, angle: useAngleForXAxisLabel ? 12 : 0 }),
                Object.values(dimensions).map((dimension) => (React.createElement(recharts.YAxis, { key: dimension.axisLabel, allowDataOverflow: true, yAxisId: dimension.isLeftYAxis ? 'left' : 'right', orientation: dimension.isLeftYAxis ? 'left' : 'right', domain: ['auto', 'auto'], type: "number", allowDecimals: false, label: yLabel(dimension), includeHidden: true, tickFormatter: formatter.format }))),
                React.createElement(recharts.Tooltip, { wrapperStyle: { outline: 'none' }, labelFormatter: DateHelper.dateToReadableFormatterFromTs, content: ({ active, payload, label }) => {
                        if (active && payload && payload.length) {
                            return (React.createElement("div", { className: "custom-tooltip" },
                                React.createElement("h4", { className: "label" }, DateHelper.dateToReadableFormatterFromTs(label)),
                                React.createElement("table", { style: { width: '100%' } },
                                    React.createElement("tbody", null, payload.map((p) => (React.createElement("tr", { key: p.name },
                                        React.createElement("td", { style: { color: p.color } }, p.name),
                                        React.createElement("td", null, (() => {
                                            const key = keyMap.get(p.dataKey);
                                            return key
                                                ? formatValue(p.value, key)
                                                : null;
                                        })()))))))));
                        }
                        return null;
                    } }),
                React.createElement(recharts.Legend, { layout: "vertical", align: "right", verticalAlign: "top", iconSize: 20, iconType: "plainline", wrapperStyle: {
                        right: '0px',
                        top: '5px',
                        height: '207px',
                        overflow: 'auto',
                        width: 'auto',
                        maxWidth: '250px',
                        minWidth: '70px',
                    } }),
                Array.from(keyMap).map(([key, value]) => (React.createElement(recharts.Line, { key: key, dataKey: key, yAxisId: dimensions[value.dimension].isLeftYAxis ? 'left' : 'right', type: "linear", stroke: getColorFromKey && getColorFromKey(value.extractedFields), strokeDasharray: getStrokeDasharray(value.dimension), strokeWidth: getStrokeWidth(value.dimension), dot: false, activeDot: { r: 5 }, isAnimationActive: true, animationDuration: 300 }))),
                refAreaLeft && refAreaRight ? (React.createElement(recharts.ReferenceArea, { yAxisId: "left", x1: refAreaLeft, x2: refAreaRight, fill: "#ccc", strokeOpacity: 0.3 })) : null))) : (React.createElement("div", null, "No data Found"))));
};

var style$1 = {"inputEditor":"InputInlineEditor-module_inputEditor__Wc-7n","input":"InputInlineEditor-module_input__TXnsR","buttons":"InputInlineEditor-module_buttons__JVegD"};

const getUrl = (props) => {
    const { urlToPatch, record } = props;
    if (typeof urlToPatch === 'function') {
        return urlToPatch(record);
    }
    return urlToPatch;
};
function sanitize(value) {
    if (typeof value === 'string') {
        return value.trim();
    }
    return value;
}
const getResponse = (props, params) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield http.HttpClient.patch(getUrl(props), params);
    return response.data;
});
const submitData = (props, state) => __awaiter(void 0, void 0, void 0, function* () {
    const { fieldName, onEditSuccess } = props;
    const params = {};
    params[fieldName] = sanitize(state.currentValue);
    if (props.pattern && !props.pattern.test(params[fieldName])) {
        messageDisplayer.displayError('Invalid input');
        return;
    }
    try {
        const response = yield getResponse(props, params);
        if (response.updated < 1) {
            messageDisplayer.displayError(response.description);
        }
        if (onEditSuccess) {
            onEditSuccess();
        }
    }
    catch (error) {
        const tunzError = error;
        messageDisplayer.displayError(tunzError.message);
    }
});

class InputInlineEditor extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { currentValue: this.props.value };
        this.handleChange = (e) => {
            this.setState({ currentValue: e.currentTarget.value });
        };
        this.submitData = () => __awaiter(this, void 0, void 0, function* () {
            yield submitData(this.props, this.state);
        });
    }
    render() {
        const { onEditCancel, fieldName } = this.props;
        const { currentValue } = this.state;
        return (React.createElement("div", { className: style$1.inputEditor },
            React.createElement("div", { className: style$1.input },
                React.createElement(reactBootstrap.Form.Control, { type: "text", value: currentValue, bsPrefix: "form-control", onChange: this.handleChange, "data-testid": `InputInlineEditor-${fieldName}` })),
            React.createElement("div", { className: style$1.buttons },
                React.createElement(reactBootstrap.Button, { onClick: onEditCancel, size: "sm", variant: "light", "data-testid": "InputInlineEditor-cancel" },
                    React.createElement(fa.FaTimes, null)),
                "\u00A0",
                React.createElement(reactBootstrap.Button, { onClick: this.submitData, size: "sm", variant: "primary", "data-testid": "InputInlineEditor-submit" },
                    React.createElement(fa.FaCheck, null)))));
    }
}

var style = {"dropdownEditor":"DropdownInlineEditor-module_dropdownEditor__eMzvh","dropdown":"DropdownInlineEditor-module_dropdown__R2AWp","buttons":"DropdownInlineEditor-module_buttons__Oku9Y"};

class DropdownInlineEditor extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { currentValue: this.props.value };
        this.handleChange = (e) => {
            this.setState({ currentValue: e.currentTarget.value });
        };
        this.submitData = () => __awaiter(this, void 0, void 0, function* () {
            yield submitData(this.props, this.state);
        });
    }
    render() {
        const { items, onEditCancel, fieldName } = this.props;
        const { currentValue } = this.state;
        return (React.createElement("div", { className: style.dropdownEditor },
            React.createElement("div", { className: style.dropdown },
                React.createElement(reactBootstrap.Form.Select, { size: "sm", value: currentValue, bsPrefix: "form-control", onChange: this.handleChange, "data-testid": `DropdownInlineEditor-${fieldName}` }, items.map((keyLabel) => (React.createElement("option", { key: keyLabel.key, value: keyLabel.key }, keyLabel.label))))),
            React.createElement("div", { className: style.buttons },
                React.createElement(reactBootstrap.Button, { onClick: onEditCancel, size: "sm", variant: "light", "data-testid": "DropdownInlineEditor-cancel" },
                    React.createElement(fa.FaTimes, null)),
                "\u00A0",
                React.createElement(reactBootstrap.Button, { onClick: this.submitData, size: "sm", variant: "primary", "data-testid": "DropdownInlineEditor-submit" },
                    React.createElement(fa.FaCheck, null)))));
    }
}

exports.BasePaginator = BasePaginator;
exports.DataDisplayer = DataDisplayer;
exports.DateRangeRestDataSource = DateRangeRestDataSource;
exports.DateRemotePaginator = DateRemotePaginator;
exports.DropdownInlineEditor = DropdownInlineEditor;
exports.EditRecordDetail = EditRecordDetail;
exports.FetchAllDataSource = FetchAllDataSource;
exports.Formatters = index;
exports.GraphDataHelper = GraphDataHelper;
exports.InputFilter = InputFilter;
exports.InputInlineEditor = InputInlineEditor;
exports.KeyHelper = KeyHelper;
exports.LocalDataSource = LocalDataSource;
exports.LocalPaginationDataSource = LocalPaginationDataSource;
exports.NumberLocalPaginator = NumberLocalPaginator;
exports.NumberRemotePaginator = NumberRemotePaginator;
exports.PagedDataSource = PagedDataSource;
exports.PagedRestDataSource = PagedRestDataSource;
exports.PagedTable = PagedTable;
exports.RawTable = RawTable;
exports.RecordDetail = RecordDetail;
exports.RemoteDataSource = RemoteDataSource;
exports.SemiRemoteDataSource = SemiRemoteDataSource;
exports.SimpleTimeLineChart = SimpleTimeLineChart;
exports.SortInfo = SortInfo;
exports.ZoomOutButton = ZoomOutButton;
exports.download = download;
exports.editRecord = edit;
exports.objectsToCSV = objectsToCSV;
